import i18n from "i18next";
import {initReactI18next, useTranslation} from "react-i18next";
import {retrieveLaunchParams} from "@telegram-apps/sdk-react";

const translates = {
  ru: {
    translation: {
      navigation: {
        main: "Главная",
        toMain: "На главную",
        allWishes: "Все желания",
      },
      state: {
        unknownError: "Возникла неизвестная ошибка. Мы уже получили уведомление и скоро всё исправим",
        temporaryUnavailable: "Сервис временно недоступен. Попробуйте позже",
        wishlistNotFound: "Вишлист не найден или удалён",
        noSubscribes: "Здесь будут отображаться вишлисты, на которые вы подпишитесь",
        noPublicWishlists: "Здесь пока нет публичных вишлистов",
        emptyWishes: "Здесь пока нет желаний",
        emptyGiftedWishes: "Пока нет желаний, отмеченных исполненными",
      },
      profile: {
        titleYourProfile: "Ваш профиль",
        titleYourWishlists: "Ваши вишлисты",
        titleUserWishlists: "Вишлисты пользователя",
        subscribes: "Подписки",
        allYourWishes: "Все ваши желания",
        giftedWishes: "Исполненные желания",
        yourGiftedWishesDescription: "Здесь отображаются ваши исполненные желания",
        userGiftedWishesDescription: "Здесь отображаются исполненные желания пользователя {{name}}",
        titleOtherProfile: "Профиль пользователя",
        settings: "Настройки",
        birthday: "День рождения",
        actionFillBirthday: "Указать",
        findFriends: "Найти вишлисты друзей",
      },
      settings: {
        profileData: "Данные профиля",
        bookedWishes: "Забронированные желания",
        hideBookings: {
          value: "Скрыть",
          description: "Вы не будете видеть, если кто-то забронировал ваши желания",
        },
        anonymousBookings: {
          value: "Показать анонимно",
          description: "Вы будете видеть, если кто-то забронировал ваши желания",
        },
        publicBookings: {
          value: "Показать имена",
          description: "Вы будете видеть имена тех, кто забронировал ваши желания",
        },
        giftedWishesVisibility: {
          value: "Отображать исполненные",
          description: "Другие пользователи будут видеть ваш раздел исполненных желаний",
          visibleDescription: "Посетители вашего профиля видят этот раздел. Изменить это можно в",
          hiddenDescription: "Посетители вашего профиля не видят этот раздел. Изменить это можно в",
          settingsLink: "настройках",
        },
        tgUsernameVisibility: {
          value: "Показывать никнейм Telegram",
          description: "Ваш публичный адрес будет отображаться в профиле",
          disabledDescription: "У вас нет публичного адреса в telegram",
        },
      },
      action: {
        apply: "Применить",
        cancel: "Отмена",
        edit: "Изменить",
        delete: "Удалить",
        clear: "Очистить",
        save: "Сохранить",
        add: "Добавить",
        subscribe: "Подписаться",
        unsubscribe: "Отписаться",
        share: "Поделиться",
        shareProfile: "Поделиться профилем",
        selectPhoto: "Выбрать фото",
        reorder: "Изменить порядок",
      },
      wish: {
        wishes: "Желания",
        action: {
          add: "Добавить желание",
          delete: "Удалить желание",
          book: "Забронировать",
          cancelBooking: "Отменить бронь",
          openLink: "Открыть ссылку",
          edit: "Редактировать желание",
          addToWishlists: "Добавить в вишлисты",
          copyWish: "Скопировать желание",
        },
        dialog: {
          delete: {
            title: "Удалить желание",
            text: "Вы уверены, что хотите удалить это желание?",
          },
          confirmHiddenBooking: "Вы скрыли отображение бронирований в настройках. Это желание может быть кем-то забронировано. Вы уверены, что хотите продолжить?",
          confirmCancelOtherBooking: "Ваше желание кем-то забронировано, и возможно уже приобретено. Вы уверены, что хотите отменить бронирование?",
        },
        placeholder: {
          title: "Название (обязательно)",
          price: "Цена",
          url: "Ссылка (https://example.com...)",
          description: "Комментарий / Описание",
        },
        gifted: {
          action: "Исполнено",
          previewLabel: "Желание",
          date: "Дата исполнения",
          withoutDate: "Без даты",
          comment: "Комментарий",
          editDescription: "Редактировать описание",
          showGiftedBy: "Показать, кто исполнил",
          showGiftedByNotificationHint: "Если включено, тот, кто забронировал, получит уведомление о перемещении в исполненные с вашим комментарием.",
          showGiftedByHint: "Если на самом деле исполнил другой человек, рекомендуем выключить эту опцию",
          confirmShowGiftedBy: "Уверены, что хотите увидеть, кто бронировал желание?",
          giftFrom: "Подарок от",
          giftToSelf: "Подарок себе",
          notLoaded: "Желание не загружено",
        },
        alreadyBooked: "(кем-то забронировано)",
        alreadyBookedMessage: "Это желание уже забронировано кем-то",
        booked: "Забронировано",
        bookedBy: "Забронировано:",
        bookedByYou: "Забронировано вами",
        alreadyCopied: "Скопировано в ваши желания",
        name: {
          empty: "Нет желаний",
          one: "желание",
          few: "желания",
          many: "желаний",
        }
      },
      idea: {
        added: "Желание добавлено",
        apply: "Добавить к себе",
        hide: "Скрыть идею",
        shouldHide: "Вы хотите скрыть эту идею? Она больше не будет отображаться в списке идей",
      },
      wishlist: {
        action: {
          delete: "Удалить вишлист",
          create: "Создать вишлист",
          edit: "Редактировать вишлист",
          selectCover: "Выбрать обложку",
        },
        dialog: {
          delete: {
            title: "Удалить вишлист",
            text: "Вы уверены, что хотите удалить этот вишлист?",
          },
        },
        placeholder: {
          title: "Название (обязательно)",
          description: "Описание",
        },
      },
      privacy: {
        title: "Приватность",
        public: {
          title: "Публичный",
          description: "Виден в вашем профиле",
          shortDescription: "Виден всем",
        },
        link: {
          title: "По ссылке",
          description: "Видят все, у кого есть ссылка",
          shortDescription: "Виден по ссылке",
        },
        private: {
          title: "Приватный",
          description: "Видят только те, кому вы разрешили",
          shortDescription: "Виден с разрешения",
        },
      },
      system: {
        birthdaySaved: "День рождения сохранен",
        unknowError: "Возникла неизвестная ошибка. Попробуйте ещё раз",
        emptyTitle: "Название не может быть пустым",
        invalidUrl: "Некорректный формат ссылки. Используйте ссылку вида \"https://...\"",
        wishDeleted: "Желание удалено",
        wishGifted: "Желание перемещено в исполненные",
        wishlistDeleted: "Вишлист удален",
        wishlistSubscribed: "Вишлист добавлен в подписки",
        wishlistUnsubscribed: "Вишлист удален из подписок",
        settingsSaved: "Настройки сохранены",
        telegramChannelLinkText: "Telegram-канал сервиса:",
        reorderSaveFailed: "Не удалось сохранить порядок желаний. Попробуйте ещё раз",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Создать"
      },
      secretSanta: {
        title: "Тайный Санта",
        myGames: "Мои игры",
        create: "Создать игру",
        organizer: "Организатор",
        participant: "Участник",
        status: {
          open: "Открыта",
          drawn: "Жеребьёвка проведена",
          completed: "Завершена"
        },
        warning: {
          title: "Вы будете организатором",
          description: "На вас будет ответственность за проведение игры",
          responsibility1: "Пригласить участников",
          responsibility2: "Провести жеребьёвку когда все готовы",
          responsibility3: "Управлять событием",
          confirm: "Понятно, создать игру",
        },
        form: {
          title: "Название игры",
          description: "Описание",
          budget: "Бюджет подарка",
          eventDate: "Дата события",
          coverImage: "Обложка",
          selectCurrency: "Выберите валюту"
        },
        share: {
          title: "Игра создана!",
          description: "Поделитесь ссылкой с участниками",
          copyLink: "Скопировать ссылку",
          shareVia: "Поделиться",
          done: "Готово",
          linkCopied: "Ссылка скопирована",
          shareText: "Присоединяйся к группе в Тайном Санте!"
        },
        participants: {
          title: "Участники",
          count: "Участников: {{count}}",
          join: "Принять участие",
          leave: "Покинуть игру",
          youParticipate: "Вы участвуете",
          edit: "Изменить данные",
          kickParticipant: "Исключить участника"
        },
        join: {
          title: "Присоединиться к игре",
          displayName: "Ваше имя в игре",
          selectWishlist: "Выберите вишлист",
          preferences: "Ваши предпочтения (необязательно)",
          submit: "Присоединиться",
          wishlist_for_santa: "Вишлист для Санты"
        },
        assignment: {
          title: "Ваш получатель",
          viewWishlist: "Посмотреть вишлист",
          preferences: "Предпочтения",
          noPreferences: "Предпочтения не указаны"
        },
        messages: {
          title: "Сообщения",
          placeholder: "Написать сообщение...",
          send: "Отправить",
          emptyState: "Начните разговор с вашим Тайным Сантой",
          secretSanta: "Тайный Санта"
        },
        actions: {
          edit: "Редактировать",
          startDraw: "Провести жеребьёвку",
          share: "Поделиться ссылкой",
          delete: "Удалить игру",
          organizerActions: "Действия организатора"
        },
        error: {
          createFailed: "Не удалось создать игру",
          joinFailed: "Не удалось присоединиться",
          drawFailed: "Не удалось провести жеребьёвку",
          insufficientParticipants: "Недостаточно участников (минимум 3)",
          alreadyJoined: "Вы уже участвуете в этой игре",
          notOpen: "Игра закрыта для новых участников",
          messageFailed: "Не удалось отправить сообщение",
          loadFailed: "Не удалось загрузить игру",
          leaveFailed: "Не удалось покинуть игру",
          updateFailed: "Не удалось обновить данные"
        },
        emptyState: {
          noGames: "У вас пока нет игр",
          createFirst: "Создайте первую игру Тайный Санта",
          noParticipants: "Пригласите участников",
          waitingForDraw: "Ожидание жеребьёвки"
        },
        dialog: {
          leaveConfirm: "Вы уверены, что хотите покинуть игру?",
          deleteConfirm: "Вы уверены, что хотите удалить игру?",
          kickConfirm: "Вы уверены, что хотите исключить этого участника из игры?",
          drawConfirm: "Вы уверены, что хотите провести жеребьёвку? После этого участники получат информацию о своих получателях. Редактирование информации и участников станет недоступно."
        }
      },
    }
  },
  en:  {
    translation: {
      navigation: {
        main: "Main",
        toMain: "To main",
        allWishes: "All wishes",
      },
      state: {
        unknownError: "An unknown error occurred. We have already received a notification and will fix everything soon",
        temporaryUnavailable: "The service is temporarily unavailable. Try again later",
        wishlistNotFound: "Wishlist not found or deleted",
        noSubscribes: "Here will be displayed wishlists you subscribed to",
        noPublicWishlists: "There are no public wishlists yet",
        emptyWishes: "There are no wishes yet",
        emptyGiftedWishes: "No wishes marked as fulfilled yet",
      },
      profile: {
        titleYourProfile: "Your profile",
        titleYourWishlists: "Your wishlists",
        titleUserWishlists: "User wishlists",
        subscribes: "Subscriptions",
        allYourWishes: "All your wishes",
        giftedWishes: "Fulfilled wishes",
        yourGiftedWishesDescription: "Your fulfilled wishes are displayed here",
        userGiftedWishesDescription: "{{name}}'s fulfilled wishes are displayed here",
        titleOtherProfile: "User profile",
        settings: "Settings",
        birthday: "Birthday",
        actionFillBirthday: "Fill",
        findFriends: "Find friends wishlists",
      },
      action: {
        apply: "Apply",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        clear: "Clear",
        save: "Save",
        add: "Add",
        subscribe: "Subscribe",
        unsubscribe: "Unsubscribe",
        share: "Share",
        shareProfile: "Share profile",
        selectPhoto: "Select photo",
        reorder: "Reorder",
      },
      wish: {
        wishes: "Wishes",
        action: {
          add: "Add wish",
          delete: "Delete wish",
          book: "Book",
          cancelBooking: "Cancel booking",
          openLink: "Open link",
          edit: "Edit wish",
          addToWishlists: "Add to wishlists",
          copyWish: "Copy wish",
        },
        dialog: {
          delete: {
            title: "Delete wish",
            text: "Are you sure you want to delete this wish?",
          },
          confirmHiddenBooking: "You have hidden the display of bookings in the settings. This wish may be booked by someone. Are you sure you want to continue?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Title (required)",
          price: "Price",
          url: "Link (https://example.com...)",
          description: "Comment / Description",
        },
        gifted: {
          action: "Fulfilled",
          previewLabel: "Wish",
          date: "Fulfillment date",
          withoutDate: "No date",
          comment: "Comment",
          editDescription: "Edit description",
          showGiftedBy: "Show who fulfilled it",
          showGiftedByNotificationHint: "If enabled, the person who booked it will receive a notification that it was moved to fulfilled with your comment.",
          showGiftedByHint: "If someone else actually fulfilled it, we recommend turning this option off",
          confirmShowGiftedBy: "Are you sure you want to see who booked the wish?",
          giftFrom: "Gift from",
          giftToSelf: "Gift to yourself",
          notLoaded: "Wish not loaded",
        },
        alreadyBooked: "(already booked)",
        alreadyBookedMessage: "This wish is already booked by someone",
        booked: "Booked",
        bookedBy: "Booked by:",
        bookedByYou: "Booked by you",
        alreadyCopied: "Copied to your wishes",
        name: {
          empty: "No wishes",
          one: "wish",
          few: "wishes",
          many: "wishes",
        },
      },
      idea: {
        added: "Wish added",
        apply: "Add to your wishes",
        hide: "Hide idea",
        shouldHide: "Do you want to hide this idea? It will no longer be shown in the ideas list",
      },
      wishlist: {
        action: {
          delete: "Delete wishlist",
          create: "Create wishlist",
          edit: "Edit wishlist",
          selectCover: "Select cover",
        },
        dialog: {
          delete: {
            title: "Delete wishlist",
            text: "Are you sure you want to delete this wishlist?",
          },
        },
        placeholder: {
          title: "Title (required)",
          description: "Description",
        },
      },
      privacy: {
        title: "Privacy",
        public: {
          title: "Public",
          description: "Visible in your profile",
          shortDescription: "Visible to everyone",
        },
        link: {
          title: "By link",
          description: "Visible to everyone with a link",
          shortDescription: "Visible by link",
        },
        private: {
          title: "Private",
          description: "Visible only to those you allow",
          shortDescription: "Visible by permission",
        },
      },
      system: {
        birthdaySaved: "Birthday saved",
        unknowError: "An unknown error occurred. Try again",
        emptyTitle: "Title cannot be empty",
        invalidUrl: "Invalid link format. Use a link like \"https://...\"",
        wishDeleted: "Wish deleted",
        wishGifted: "Wish moved to fulfilled",
        wishlistDeleted: "Wishlist deleted",
        wishlistSubscribed: "Wishlist added to subscribes",
        wishlistUnsubscribed: "Wishlist removed from subscribes",
        settingsSaved: "Settings saved",
        telegramChannelLinkText: "Service Telegram channel:",
        reorderSaveFailed: "Failed to save wish order. Please try again",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Create"
      },
      settings: {
        profileData: "Profile data",
        bookedWishes: "Booked wishes",
        hideBookings: {
          value: "Hide",
          description: "You won't see if someone has booked your wishes",
        },
        anonymousBookings: {
          value: "Show anonymously",
          description: "You will see if someone has booked your wishes",
        },
        publicBookings: {
          value: "Show names",
          description: "You will see the names of those who have booked your wishes",
        },
        giftedWishesVisibility: {
          value: "Show fulfilled",
          description: "Other users will see your fulfilled wishes section",
          visibleDescription: "Visitors to your profile see this section. You can change this in",
          hiddenDescription: "Visitors to your profile do not see this section. You can change this in",
          settingsLink: "settings",
        },
        tgUsernameVisibility: {
          value: "Show Telegram username",
          description: "Your public address will be visible in your profile",
          disabledDescription: "You do not have a public Telegram address",
        },
      },
      secretSanta: {
        title: "Secret Santa",
        myGames: "My games",
        create: "Create game",
        organizer: "Organizer",
        participant: "Participant",
        status: {
          open: "Open",
          drawn: "Draw completed",
          completed: "Completed"
        },
        warning: {
          title: "You will be the organizer",
          description: "You will be responsible for running the game",
          responsibility1: "Invite participants",
          responsibility2: "Start the draw when everyone is ready",
          responsibility3: "Manage the event",
          confirm: "Got it, create game",
        },
        form: {
          title: "Game title",
          description: "Description",
          budget: "Gift budget",
          eventDate: "Event date",
          coverImage: "Cover image",
          selectCurrency: "Select currency"
        },
        share: {
          title: "Game created!",
          description: "Share the link with participants",
          copyLink: "Copy link",
          shareVia: "Share",
          done: "Done",
          linkCopied: "Link copied",
          shareText: "Join the Secret Santa group!"
        },
        participants: {
          title: "Participants",
          count: "Participants: {{count}}",
          join: "Join",
          leave: "Leave game",
          youParticipate: "You participate",
          edit: "Edit info",
          kickParticipant: "Kick participant"
        },
        join: {
          title: "Join game",
          displayName: "Your name in the game",
          selectWishlist: "Select wishlist",
          preferences: "Your preferences (optional)",
          submit: "Join",
          wishlist_for_santa: "Wishlist for santa"
        },
        assignment: {
          title: "Your recipient",
          viewWishlist: "View wishlist",
          preferences: "Preferences",
          noPreferences: "No preferences specified"
        },
        messages: {
          title: "Messages",
          placeholder: "Write a message...",
          send: "Send",
          emptyState: "Start a conversation with your Secret Santa",
          secretSanta: "Secret Santa"
        },
        actions: {
          edit: "Edit",
          startDraw: "Start draw",
          share: "Share link",
          delete: "Delete game",
          organizerActions: "Organizer actions"
        },
        error: {
          createFailed: "Failed to create game",
          joinFailed: "Failed to join",
          drawFailed: "Failed to start draw",
          insufficientParticipants: "Not enough participants (minimum 3)",
          alreadyJoined: "You already participate in this game",
          notOpen: "Game is closed for new participants",
          messageFailed: "Failed to send message",
          loadFailed: "Failed to load game",
          leaveFailed: "Failed to leave game",
          updateFailed: "Failed to update info"
        },
        emptyState: {
          noGames: "You don't have any games yet",
          createFirst: "Create your first Secret Santa game",
          noParticipants: "Invite participants",
          waitingForDraw: "Waiting for draw"
        },
        dialog: {
          leaveConfirm: "Are you sure you want to leave the game?",
          deleteConfirm: "Are you sure you want to delete the game?",
          kickConfirm: "Are you sure you want to kick this participant from the game?",
          drawConfirm: "Are you sure you want to start the draw? After that, participants will receive information about their recipients. Editing information and participants will become unavailable."
        }
      },
    },
  },
  uk: {
    translation: {
      navigation: {
        main: "Головна",
        toMain: "На головну",
        allWishes: "Всі бажання",
      },
      state: {
        unknownError: "Виникла невідома помилка. Ми вже отримали сповіщення і скоро все виправимо",
        temporaryUnavailable: "Сервіс тимчасово недоступний. Спробуйте пізніше",
        wishlistNotFound: "Список бажань не знайдено або видалено",
        noSubscribes: "Тут будуть відображатися списки бажань, на які ви підпишетесь",
        noPublicWishlists: "Тут поки немає публічних списків бажань",
        emptyWishes: "Тут поки немає бажань",
        emptyGiftedWishes: "Поки немає бажань, позначених виконаними",
      },
      profile: {
        titleYourProfile: "Ваш профіль",
        titleYourWishlists: "Ваші списки бажань",
        titleUserWishlists: "Списки бажань користувача",
        subscribes: "Підписки",
        allYourWishes: "Всі ваші бажання",
        giftedWishes: "Виконані бажання",
        yourGiftedWishesDescription: "Тут відображаються ваші виконані бажання",
        userGiftedWishesDescription: "Тут відображаються виконані бажання користувача {{name}}",
        titleOtherProfile: "Профіль користувача",
        settings: "Налаштування",
        birthday: "День народження",
        actionFillBirthday: "Вказати",
        findFriends: "Знайти списки бажань друзів",
      },
      settings: {
        profileData: "Дані профілю",
        bookedWishes: "Заброньовані бажання",
        hideBookings: {
          value: "Приховати",
          description: "Ви не будете бачити, якщо хтось забронював ваші бажання",
        },
        anonymousBookings: {
          value: "Показати анонімно",
          description: "Ви будете бачити, якщо хтось забронював ваші бажання",
        },
        publicBookings: {
          value: "Показати імена",
          description: "Ви будете бачити імена тих, хто забронював ваші бажання",
        },
        giftedWishesVisibility: {
          value: "Показувати виконані",
          description: "Інші користувачі бачитимуть ваш розділ виконаних бажань",
          visibleDescription: "Відвідувачі вашого профілю бачать цей розділ. Змінити це можна в",
          hiddenDescription: "Відвідувачі вашого профілю не бачать цей розділ. Змінити це можна в",
          settingsLink: "налаштуваннях",
        },
        tgUsernameVisibility: {
          value: "Показувати username Telegram",
          description: "Ваш публічний адрес буде відображатися у профілі",
          disabledDescription: "У вас немає публічного адреса в telegram",
        },
      },
      action: {
        apply: "Застосувати",
        cancel: "Скасувати",
        edit: "Змінити",
        delete: "Видалити",
        clear: "Очистити",
        save: "Зберегти",
        add: "Додати",
        subscribe: "Підписатися",
        unsubscribe: "Відписатися",
        share: "Поділитися",
        shareProfile: "Поділитися профілем",
        selectPhoto: "Вибрати фото",
        reorder: "Змінити порядок",
      },
      wish: {
        wishes: "Бажання",
        action: {
          add: "Додати бажання",
          delete: "Видалити бажання",
          book: "Забронювати",
          cancelBooking: "Скасувати бронювання",
          openLink: "Відкрити посилання",
          edit: "Редагувати бажання",
          addToWishlists: "Додати до списків бажань",
          copyWish: "Скопіювати бажання",
        },
        dialog: {
          delete: {
            title: "Видалити бажання",
            text: "Ви впевнені, що хочете видалити це бажання?",
          },
          confirmHiddenBooking: "Ви приховали відображення бронювань в налаштуваннях. Це бажання може бути кимось заброньоване. Ви впевнені, що хочете продовжити?",
          confirmCancelOtherBooking: "Ваше бажання кимось заброньовано і, можливо, вже придбано. Ви впевнені, що хочете скасувати бронювання?",
        },
        placeholder: {
          title: "Назва (обов'язково)",
          price: "Ціна",
          url: "Посилання (https://example.com...)",
          description: "Коментар / Опис",
        },
        gifted: {
          action: "Виконано",
          previewLabel: "Бажання",
          date: "Дата виконання",
          withoutDate: "Без дати",
          comment: "Коментар",
          editDescription: "Редагувати опис",
          showGiftedBy: "Показати, хто виконав",
          showGiftedByNotificationHint: "Якщо увімкнено, той, хто забронював, отримає сповіщення про переміщення до виконаних із вашим коментарем.",
          showGiftedByHint: "Якщо насправді виконала інша людина, рекомендуємо вимкнути цю опцію",
          confirmShowGiftedBy: "Ви впевнені, що хочете побачити, хто бронював бажання?",
          giftFrom: "Подарунок від",
          giftToSelf: "Подарунок собі",
          notLoaded: "Бажання не завантажено",
        },
        alreadyBooked: "(кимось заброньовано)",
        alreadyBookedMessage: "Це бажання вже кимось заброньовано",
        booked: "Заброньовано",
        bookedBy: "Заброньовано:",
        bookedByYou: "Заброньовано вами",
        alreadyCopied: "Скопійовано до ваших бажань",
        name: {
          empty: "Немає бажань",
          one: "бажання",
          few: "бажання",
          many: "бажань",
        }
      },
      idea: {
        added: "Бажання додано",
        apply: "Додати до себе",
        hide: "Приховати ідею",
        shouldHide: "Ви хочете приховати цю ідею? Вона більше не буде відображатися в списку ідей",
      },
      wishlist: {
        action: {
          delete: "Видалити список бажань",
          create: "Створити список бажань",
          edit: "Редагувати список бажань",
          selectCover: "Вибрати обкладинку",
        },
        dialog: {
          delete: {
            title: "Видалити список бажань",
            text: "Ви впевнені, що хочете видалити цей список бажань?",
          },
        },
        placeholder: {
          title: "Назва (обов'язково)",
          description: "Опис",
        },
      },
      privacy: {
        title: "Приватність",
        public: {
          title: "Публічний",
          description: "Видно у вашому профілі",
          shortDescription: "Видно всім",
        },
        link: {
          title: "За посиланням",
          description: "Бачать всі, у кого є посилання",
          shortDescription: "Видно за посиланням",
        },
        private: {
          title: "Приватний",
          description: "Бачать тільки ті, кому ви дозволили",
          shortDescription: "Видно з дозволу",
        },
      },
      system: {
        birthdaySaved: "День народження збережено",
        unknowError: "Виникла невідома помилка. Спробуйте ще раз",
        emptyTitle: "Назва не може бути порожньою",
        invalidUrl: "Некоректний формат посилання. Використовуйте посилання виду \"https://...\"",
        wishDeleted: "Бажання видалено",
        wishGifted: "Бажання переміщено до виконаних",
        wishlistDeleted: "Список бажань видалено",
        wishlistSubscribed: "Список бажань додано до підписок",
        wishlistUnsubscribed: "Список бажань видалено з підписок",
        settingsSaved: "Налаштування збережено",
        telegramChannelLinkText: "Telegram-канал сервісу:",
        reorderSaveFailed: "Не вдалося зберегти порядок бажань. Спробуйте ще раз",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Створити"
      },
      secretSanta: {
        title: "Таємний Санта",
        myGames: "Мої ігри",
        create: "Створити гру",
        organizer: "Організатор",
        participant: "Учасник",
        status: {
          open: "Відкрита",
          drawn: "Жеребкування проведено",
          completed: "Завершена"
        },
        warning: {
          title: "Ви будете організатором",
          description: "На вас буде відповідальність за проведення гри",
          responsibility1: "Запросити учасників",
          responsibility2: "Провести жеребкування коли всі готові",
          responsibility3: "Керувати подією",
          confirm: "Зрозуміло, створити гру",
        },
        form: {
          title: "Назва гри",
          description: "Опис",
          budget: "Бюджет подарунка",
          eventDate: "Дата події",
          coverImage: "Обкладинка",
          selectCurrency: "Виберіть валюту"
        },
        share: {
          title: "Гру створено!",
          description: "Поділіться посиланням з учасниками",
          copyLink: "Скопіювати посилання",
          shareVia: "Поділитися",
          done: "Готово",
          linkCopied: "Посилання скопійовано",
          shareText: "Приєднуйся до групи в Таємному Санті!"
        },
        participants: {
          title: "Учасники",
          count: "Учасників: {{count}}",
          join: "Приєднатися",
          leave: "Покинути гру",
          youParticipate: "Ви берете участь",
          edit: "Змінити дані",
          kickParticipant: "Виключити учасника"
        },
        join: {
          title: "Приєднатися до гри",
          displayName: "Ваше ім'я в грі",
          selectWishlist: "Виберіть список бажань",
          preferences: "Ваші вподобання (необов'язково)",
          submit: "Приєднатися",
          wishlist_for_santa: "Список бажань для Санти"
        },
        assignment: {
          title: "Ваш одержувач",
          viewWishlist: "Подивитися список бажань",
          preferences: "Вподобання",
          noPreferences: "Вподобання не вказано"
        },
        messages: {
          title: "Повідомлення",
          placeholder: "Написати повідомлення...",
          send: "Відправити",
          emptyState: "Почніть розмову з вашим Таємним Сантою",
          secretSanta: "Таємний Санта"
        },
        actions: {
          edit: "Редагувати",
          startDraw: "Провести жеребкування",
          share: "Поділитися посиланням",
          delete: "Видалити гру",
          organizerActions: "Дії організатора"
        },
        error: {
          createFailed: "Не вдалося створити гру",
          joinFailed: "Не вдалося приєднатися",
          drawFailed: "Не вдалося провести жеребкування",
          insufficientParticipants: "Недостатньо учасників (мінімум 3)",
          alreadyJoined: "Ви вже берете участь у цій грі",
          notOpen: "Гра закрита для нових учасників",
          messageFailed: "Не вдалося відправити повідомлення",
          loadFailed: "Не вдалося завантажити гру",
          leaveFailed: "Не вдалося покинути гру",
          updateFailed: "Не вдалося оновити дані"
        },
        emptyState: {
          noGames: "У вас поки немає ігор",
          createFirst: "Створіть першу гру Таємний Санта",
          noParticipants: "Запросіть учасників",
          waitingForDraw: "Очікування жеребкування"
        },
        dialog: {
          leaveConfirm: "Ви впевнені, що хочете покинути гру?",
          deleteConfirm: "Ви впевнені, що хочете видалити гру?",
          kickConfirm: "Ви впевнені, що хочете виключити цього учасника з гри?",
          drawConfirm: "Ви впевнені, що хочете провести жеребкування? Після цього учасники отримають інформацію про своїх одержувачів. Редагування інформації та учасників стане недоступним."
        }
      },
    }
  },
  id: {
    translation: {
      navigation: {
        main: "Utama",
        toMain: "Ke Utama",
        allWishes: "Semua Keinginan",
      },
      state: {
        unknownError: "Terjadi kesalahan yang tidak diketahui. Kami telah menerima pemberitahuan dan akan segera memperbaikinya",
        temporaryUnavailable: "Layanan sementara tidak tersedia. Silakan coba lagi nanti",
        wishlistNotFound: "Wishlist tidak ditemukan atau dihapus",
        noSubscribes: "Di sini akan ditampilkan wishlist yang Anda ikuti",
        noPublicWishlists: "Belum ada wishlist publik",
        emptyWishes: "Belum ada keinginan",
        emptyGiftedWishes: "Belum ada keinginan yang ditandai sebagai terpenuhi",
      },
      profile: {
        titleYourProfile: "Profil Anda",
        titleYourWishlists: "Wishlist Anda",
        titleUserWishlists: "Wishlist pengguna",
        subscribes: "Langganan",
        allYourWishes: "Semua keinginan Anda",
        giftedWishes: "Keinginan yang terpenuhi",
        yourGiftedWishesDescription: "Keinginan terpenuhi Anda ditampilkan di sini",
        userGiftedWishesDescription: "Keinginan terpenuhi milik {{name}} ditampilkan di sini",
        titleOtherProfile: "Profil pengguna",
        settings: "Pengaturan",
        birthday: "Tanggal lahir",
        actionFillBirthday: "Isi",
        findFriends: "Temukan wishlist teman",
      },
      settings: {
        profileData: "Data profil",
        bookedWishes: "Keinginan yang dipesan",
        hideBookings: {
          value: "Sembunyikan",
          description: "Anda tidak akan melihat jika seseorang memesan keinginan Anda",
        },
        anonymousBookings: {
          value: "Tampilkan secara anonim",
          description: "Anda akan melihat jika seseorang memesan keinginan Anda",
        },
        publicBookings: {
          value: "Tampilkan nama",
          description: "Anda akan melihat nama orang yang memesan keinginan Anda",
        },
        giftedWishesVisibility: {
          value: "Tampilkan yang terpenuhi",
          description: "Pengguna lain akan melihat bagian keinginan terpenuhi Anda",
          visibleDescription: "Pengunjung profil Anda melihat bagian ini. Anda dapat mengubahnya di",
          hiddenDescription: "Pengunjung profil Anda tidak melihat bagian ini. Anda dapat mengubahnya di",
          settingsLink: "pengaturan",
        },
        tgUsernameVisibility: {
          value: "Tampilkan username Telegram",
          description: "Alamat publik Anda akan ditampilkan di profil",
          disabledDescription: "Anda tidak memiliki alamat publik di telegram",
        },
      },
      action: {
        apply: "Terapkan",
        cancel: "Batal",
        edit: "Edit",
        delete: "Hapus",
        clear: "Bersihkan",
        save: "Simpan",
        add: "Tambah",
        subscribe: "Berlangganan",
        unsubscribe: "Berhenti berlangganan",
        share: "Bagikan",
        shareProfile: "Bagikan profil",
        selectPhoto: "Pilih foto",
        reorder: "Ubah urutan",
      },
      wish: {
        wishes: "Keinginan",
        action: {
          add: "Tambah keinginan",
          delete: "Hapus keinginan",
          book: "Pesan",
          cancelBooking: "Batalkan pesanan",
          openLink: "Buka tautan",
          edit: "Edit keinginan",
          addToWishlists: "Tambahkan ke wishlist",
          copyWish: "Salin keinginan",
        },
        dialog: {
          delete: {
            title: "Hapus keinginan",
            text: "Apakah Anda yakin ingin menghapus keinginan ini?",
          },
          confirmHiddenBooking: "Anda telah menyembunyikan tampilan pemesanan di pengaturan. Keinginan ini mungkin telah dipesan oleh seseorang. Apakah Anda yakin ingin melanjutkan?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Judul (wajib)",
          price: "Harga",
          url: "Tautan (https://example.com...)",
          description: "Komentar / Deskripsi",
        },
        gifted: {
          action: "Terpenuhi",
          previewLabel: "Keinginan",
          date: "Tanggal terpenuhi",
          withoutDate: "Tanpa tanggal",
          comment: "Komentar",
          editDescription: "Edit description",
          showGiftedBy: "Tampilkan yang memenuhi",
          showGiftedByNotificationHint: "Jika diaktifkan, orang yang memesannya akan menerima notifikasi bahwa keinginan ini dipindahkan ke terpenuhi dengan komentar Anda.",
          showGiftedByHint: "Jika sebenarnya dipenuhi oleh orang lain, sebaiknya matikan opsi ini",
          confirmShowGiftedBy: "Yakin ingin melihat siapa yang memesan keinginan ini?",
          giftFrom: "Hadiah dari",
          giftToSelf: "Hadiah untuk diri sendiri",
          notLoaded: "Keinginan tidak dimuat",
        },
        alreadyBooked: "(sudah dipesan)",
        alreadyBookedMessage: "Keinginan ini sudah dipesan oleh seseorang",
        booked: "Dipesan",
        bookedBy: "Dipesan oleh:",
        bookedByYou: "Dipesan oleh Anda",
        alreadyCopied: "Disalin ke keinginan Anda",
        name: {
          empty: "Tidak ada keinginan",
          one: "keinginan",
          few: "keinginan",
          many: "keinginan",
        }
      },
      idea: {
        added: "Keinginan ditambahkan",
        apply: "Tambahkan ke milik Anda",
        hide: "Sembunyikan ide",
        shouldHide: "Apakah Anda ingin menyembunyikan ide ini? Ide ini tidak akan ditampilkan lagi di daftar ide",
      },
      wishlist: {
        action: {
          delete: "Hapus wishlist",
          create: "Buat wishlist",
          edit: "Edit wishlist",
          selectCover: "Pilih sampul",
        },
        dialog: {
          delete: {
            title: "Hapus wishlist",
            text: "Apakah Anda yakin ingin menghapus wishlist ini?",
          },
        },
        placeholder: {
          title: "Judul (wajib)",
          description: "Deskripsi",
        },
      },
      privacy: {
        title: "Privasi",
        public: {
          title: "Publik",
          description: "Terlihat di profil Anda",
          shortDescription: "Terlihat oleh semua orang",
        },
        link: {
          title: "Melalui tautan",
          description: "Terlihat oleh semua orang yang memiliki tautan",
          shortDescription: "Terlihat melalui tautan",
        },
        private: {
          title: "Pribadi",
          description: "Hanya terlihat oleh orang yang Anda izinkan",
          shortDescription: "Terlihat dengan izin",
        },
      },
      system: {
        birthdaySaved: "Tanggal lahir disimpan",
        unknowError: "Terjadi kesalahan yang tidak diketahui. Coba lagi",
        emptyTitle: "Judul tidak boleh kosong",
        invalidUrl: "Format tautan tidak valid. Gunakan tautan seperti \"https://...\"",
        wishDeleted: "Keinginan dihapus",
        wishGifted: "Keinginan dipindahkan ke terpenuhi",
        wishlistDeleted: "Wishlist dihapus",
        wishlistSubscribed: "Wishlist ditambahkan ke langganan",
        wishlistUnsubscribed: "Wishlist dihapus dari langganan",
        settingsSaved: "Pengaturan disimpan",
        telegramChannelLinkText: "Kanal Telegram layanan:",
        reorderSaveFailed: "Gagal menyimpan urutan keinginan. Silakan coba lagi",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Buat"
      },
      secretSanta: {
        title: "Secret Santa",
        myGames: "Permainan saya",
        create: "Buat permainan",
        organizer: "Penyelenggara",
        participant: "Peserta",
        status: {
          open: "Terbuka",
          drawn: "Undian selesai",
          completed: "Selesai"
        },
        warning: {
          title: "Anda akan menjadi penyelenggara",
          description: "Anda akan bertanggung jawab menjalankan permainan",
          responsibility1: "Undang peserta",
          responsibility2: "Mulai undian ketika semua siap",
          responsibility3: "Kelola acara",
          confirm: "Mengerti, buat permainan",
        },
        form: {
          title: "Judul permainan",
          description: "Deskripsi",
          budget: "Anggaran hadiah",
          eventDate: "Tanggal acara",
          coverImage: "Gambar sampul",
          selectCurrency: "Pilih mata uang"
        },
        share: {
          title: "Permainan dibuat!",
          description: "Bagikan tautan dengan peserta",
          copyLink: "Salin tautan",
          shareVia: "Bagikan",
          done: "Selesai",
          linkCopied: "Tautan disalin",
          shareText: "Bergabunglah dengan grup Secret Santa!"
        },
        participants: {
          title: "Peserta",
          count: "Peserta: {{count}}",
          join: "Bergabung",
          leave: "Tinggalkan permainan",
          youParticipate: "Anda berpartisipasi",
          edit: "Edit info",
          kickParticipant: "Keluarkan peserta"
        },
        join: {
          title: "Bergabung dengan permainan",
          displayName: "Nama Anda dalam permainan",
          selectWishlist: "Pilih wishlist",
          preferences: "Preferensi Anda (opsional)",
          submit: "Bergabung",
          wishlist_for_santa: "Wishlist untuk santa"
        },
        assignment: {
          title: "Penerima Anda",
          viewWishlist: "Lihat wishlist",
          preferences: "Preferensi",
          noPreferences: "Tidak ada preferensi"
        },
        messages: {
          title: "Pesan",
          placeholder: "Tulis pesan...",
          send: "Kirim",
          emptyState: "Mulai percakapan dengan Secret Santa Anda",
          secretSanta: "Secret Santa"
        },
        actions: {
          edit: "Edit",
          startDraw: "Mulai undian",
          share: "Bagikan tautan",
          delete: "Hapus permainan",
          organizerActions: "Tindakan penyelenggara"
        },
        error: {
          createFailed: "Gagal membuat permainan",
          joinFailed: "Gagal bergabung",
          drawFailed: "Gagal memulai undian",
          insufficientParticipants: "Peserta tidak cukup (minimal 3)",
          alreadyJoined: "Anda sudah berpartisipasi dalam permainan ini",
          notOpen: "Permainan ditutup untuk peserta baru",
          messageFailed: "Gagal mengirim pesan",
          loadFailed: "Gagal memuat permainan",
          leaveFailed: "Gagal meninggalkan permainan",
          updateFailed: "Gagal memperbarui info"
        },
        emptyState: {
          noGames: "Anda belum memiliki permainan",
          createFirst: "Buat permainan Secret Santa pertama Anda",
          noParticipants: "Undang peserta",
          waitingForDraw: "Menunggu undian"
        },
        dialog: {
          leaveConfirm: "Apakah Anda yakin ingin meninggalkan permainan?",
          deleteConfirm: "Apakah Anda yakin ingin menghapus permainan?",
          kickConfirm: "Apakah Anda yakin ingin mengeluarkan peserta ini dari permainan?",
          drawConfirm: "Apakah Anda yakin ingin memulai undian? Setelah itu, peserta akan menerima informasi tentang penerima mereka. Pengeditan informasi dan peserta akan menjadi tidak tersedia."
        }
      },
    }
  },
  pt: {
    translation: {
      navigation: {
        main: "Principal",
        toMain: "Para principal",
        allWishes: "Todos os desejos",
      },
      state: {
        unknownError: "Ocorreu um erro desconhecido. Já recebemos uma notificação e corrigiremos tudo em breve",
        temporaryUnavailable: "O serviço está temporariamente indisponível. Tente novamente mais tarde",
        wishlistNotFound: "Lista de desejos não encontrada ou excluída",
        noSubscribes: "Aqui serão exibidas as listas de desejos que você seguir",
        noPublicWishlists: "Ainda não há listas de desejos públicas",
        emptyWishes: "Ainda não há desejos",
        emptyGiftedWishes: "Ainda não há desejos marcados como realizados",
      },
      profile: {
        titleYourProfile: "Seu perfil",
        titleYourWishlists: "Suas listas de desejos",
        titleUserWishlists: "Listas de desejos do usuário",
        subscribes: "Inscrições",
        allYourWishes: "Todos os seus desejos",
        giftedWishes: "Desejos realizados",
        yourGiftedWishesDescription: "Seus desejos realizados são exibidos aqui",
        userGiftedWishesDescription: "Os desejos realizados de {{name}} são exibidos aqui",
        titleOtherProfile: "Perfil do usuário",
        settings: "Configurações",
        birthday: "Aniversário",
        actionFillBirthday: "Preencher",
        findFriends: "Encontrar listas de desejos dos amigos",
      },
      settings: {
        profileData: "Dados do perfil",
        bookedWishes: "Desejos reservados",
        hideBookings: {
          value: "Ocultar",
          description: "Você não verá se alguém reservou seus desejos",
        },
        anonymousBookings: {
          value: "Mostrar anonimamente",
          description: "Você verá se alguém reservou seus desejos",
        },
        publicBookings: {
          value: "Mostrar nomes",
          description: "Você verá os nomes de quem reservou seus desejos",
        },
        giftedWishesVisibility: {
          value: "Mostrar realizados",
          description: "Outros usuários verão sua seção de desejos realizados",
          visibleDescription: "Visitantes do seu perfil veem esta seção. Você pode alterar isso em",
          hiddenDescription: "Visitantes do seu perfil não veem esta seção. Você pode alterar isso em",
          settingsLink: "configurações",
        },
        tgUsernameVisibility: {
          value: "Mostrar username do Telegram",
          description: "Seu endereço público será exibido no perfil",
          disabledDescription: "Você não tem um endereço público no telegram",
        },
      },
      action: {
        apply: "Aplicar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Excluir",
        clear: "Limpar",
        save: "Salvar",
        add: "Adicionar",
        subscribe: "Seguir",
        unsubscribe: "Deixar de seguir",
        share: "Compartilhar",
        shareProfile: "Compartilhar perfil",
        selectPhoto: "Selecionar foto",
        reorder: "Reordenar",
      },
      wish: {
        wishes: "Desejos",
        action: {
          add: "Adicionar desejo",
          delete: "Excluir desejo",
          book: "Reservar",
          cancelBooking: "Cancelar reserva",
          openLink: "Abrir link",
          edit: "Editar desejo",
          addToWishlists: "Adicionar às listas de desejos",
          copyWish: "Copiar desejo",
        },
        dialog: {
          delete: {
            title: "Excluir desejo",
            text: "Tem certeza que deseja excluir este desejo?",
          },
          confirmHiddenBooking: "Você ocultou a exibição de reservas nas configurações. Este desejo pode estar reservado por alguém. Tem certeza que deseja continuar?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Título (obrigatório)",
          price: "Preço",
          url: "Link (https://example.com...)",
          description: "Comentário / Descrição",
        },
        gifted: {
          action: "Realizado",
          previewLabel: "Desejo",
          date: "Data de realização",
          withoutDate: "Sem data",
          comment: "Comentário",
          editDescription: "Editar descrição",
          showGiftedBy: "Mostrar quem realizou",
          showGiftedByNotificationHint: "Se ativado, quem reservou receberá uma notificação de que o desejo foi movido para realizados com seu comentário.",
          showGiftedByHint: "Se outra pessoa realmente realizou o desejo, recomendamos desativar esta opção",
          confirmShowGiftedBy: "Tem certeza de que deseja ver quem reservou este desejo?",
          giftFrom: "Presente de",
          giftToSelf: "Presente para si",
          notLoaded: "Desejo não carregado",
        },
        alreadyBooked: "(já reservado)",
        alreadyBookedMessage: "Este desejo já foi reservado por alguém",
        booked: "Reservado",
        bookedBy: "Reservado por:",
        bookedByYou: "Reservado por você",
        alreadyCopied: "Copiado para seus desejos",
        name: {
          empty: "Sem desejos",
          one: "desejo",
          few: "desejos",
          many: "desejos",
        }
      },
      idea: {
        added: "Desejo adicionado",
        apply: "Adicionar aos seus",
        hide: "Ocultar ideia",
        shouldHide: "Deseja ocultar esta ideia? Ela não será mais exibida na lista de ideias",
      },
      wishlist: {
        action: {
          delete: "Excluir lista de desejos",
          create: "Criar lista de desejos",
          edit: "Editar lista de desejos",
          selectCover: "Selecionar capa",
        },
        dialog: {
          delete: {
            title: "Excluir lista de desejos",
            text: "Tem certeza que deseja excluir esta lista de desejos?",
          },
        },
        placeholder: {
          title: "Título (obrigatório)",
          description: "Descrição",
        },
      },
      privacy: {
        title: "Privacidade",
        public: {
          title: "Público",
          description: "Visível no seu perfil",
          shortDescription: "Visível para todos",
        },
        link: {
          title: "Por link",
          description: "Visível para todos que têm o link",
          shortDescription: "Visível por link",
        },
        private: {
          title: "Privado",
          description: "Visível apenas para quem você permitir",
          shortDescription: "Visível com permissão",
        },
      },
      system: {
        birthdaySaved: "Aniversário salvo",
        unknowError: "Ocorreu um erro desconhecido. Tente novamente",
        emptyTitle: "O título não pode estar vazio",
        invalidUrl: "Formato de link inválido. Use um link como \"https://...\"",
        wishDeleted: "Desejo excluído",
        wishGifted: "Desejo movido para realizados",
        wishlistDeleted: "Lista de desejos excluída",
        wishlistSubscribed: "Lista de desejos adicionada às inscrições",
        wishlistUnsubscribed: "Lista de desejos removida das inscrições",
        settingsSaved: "Configurações salvas",
        telegramChannelLinkText: "Canal do Telegram do serviço:",
        reorderSaveFailed: "Falha ao salvar ordem dos desejos. Tente novamente",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Criar"
      },
      secretSanta: {
        title: "Amigo Secreto",
        myGames: "Meus jogos",
        create: "Criar jogo",
        organizer: "Organizador",
        participant: "Participante",
        status: {
          open: "Aberto",
          drawn: "Sorteio realizado",
          completed: "Concluído"
        },
        warning: {
          title: "Você será o organizador",
          description: "Você será responsável por conduzir o jogo",
          responsibility1: "Convidar participantes",
          responsibility2: "Iniciar o sorteio quando todos estiverem prontos",
          responsibility3: "Gerenciar o evento",
          confirm: "Entendi, criar jogo",
        },
        form: {
          title: "Título do jogo",
          description: "Descrição",
          budget: "Orçamento do presente",
          eventDate: "Data do evento",
          coverImage: "Imagem de capa",
          selectCurrency: "Selecionar moeda"
        },
        share: {
          title: "Jogo criado!",
          description: "Compartilhe o link com os participantes",
          copyLink: "Copiar link",
          shareVia: "Compartilhar",
          done: "Concluído",
          linkCopied: "Link copiado",
          shareText: "Participe do grupo Amigo Secreto!"
        },
        participants: {
          title: "Participantes",
          count: "Participantes: {{count}}",
          join: "Participar",
          leave: "Sair do jogo",
          youParticipate: "Você participa",
          edit: "Editar informações",
          kickParticipant: "Expulsar participante"
        },
        join: {
          title: "Participar do jogo",
          displayName: "Seu nome no jogo",
          selectWishlist: "Selecionar lista de desejos",
          preferences: "Suas preferências (opcional)",
          submit: "Participar",
          wishlist_for_santa: "Lista de desejos para o Papai Noel"
        },
        assignment: {
          title: "Seu destinatário",
          viewWishlist: "Ver lista de desejos",
          preferences: "Preferências",
          noPreferences: "Nenhuma preferência especificada"
        },
        messages: {
          title: "Mensagens",
          placeholder: "Escrever mensagem...",
          send: "Enviar",
          emptyState: "Inicie uma conversa com seu Amigo Secreto",
          secretSanta: "Amigo Secreto"
        },
        actions: {
          edit: "Editar",
          startDraw: "Iniciar sorteio",
          share: "Compartilhar link",
          delete: "Excluir jogo",
          organizerActions: "Ações do organizador"
        },
        error: {
          createFailed: "Falha ao criar jogo",
          joinFailed: "Falha ao participar",
          drawFailed: "Falha ao iniciar sorteio",
          insufficientParticipants: "Participantes insuficientes (mínimo 3)",
          alreadyJoined: "Você já participa deste jogo",
          notOpen: "Jogo fechado para novos participantes",
          messageFailed: "Falha ao enviar mensagem",
          loadFailed: "Falha ao carregar jogo",
          leaveFailed: "Falha ao sair do jogo",
          updateFailed: "Falha ao atualizar informações"
        },
        emptyState: {
          noGames: "Você ainda não tem jogos",
          createFirst: "Crie seu primeiro jogo de Amigo Secreto",
          noParticipants: "Convide participantes",
          waitingForDraw: "Aguardando sorteio"
        },
        dialog: {
          leaveConfirm: "Tem certeza que deseja sair do jogo?",
          deleteConfirm: "Tem certeza que deseja excluir o jogo?",
          kickConfirm: "Tem certeza que deseja expulsar este participante do jogo?",
          drawConfirm: "Tem certeza que deseja iniciar o sorteio? Após isso, os participantes receberão informações sobre seus destinatários. A edição de informações e participantes se tornará indisponível."
        }
      },
    }
  },
  es: {
    translation: {
      navigation: {
        main: "Principal",
        toMain: "A principal",
        allWishes: "Todos los deseos",
      },
      state: {
        unknownError: "Ha ocurrido un error desconocido. Ya hemos recibido una notificación y lo arreglaremos pronto",
        temporaryUnavailable: "El servicio no está disponible temporalmente. Inténtelo más tarde",
        wishlistNotFound: "Lista de deseos no encontrada o eliminada",
        noSubscribes: "Aquí se mostrarán las listas de deseos a las que te suscribas",
        noPublicWishlists: "Aún no hay listas de deseos públicas",
        emptyWishes: "Aún no hay deseos",
        emptyGiftedWishes: "Aún no hay deseos marcados como cumplidos",
      },
      profile: {
        titleYourProfile: "Tu perfil",
        titleYourWishlists: "Tus listas de deseos",
        titleUserWishlists: "Listas de deseos del usuario",
        subscribes: "Suscripciones",
        allYourWishes: "Todos tus deseos",
        giftedWishes: "Deseos cumplidos",
        yourGiftedWishesDescription: "Aquí se muestran tus deseos cumplidos",
        userGiftedWishesDescription: "Aquí se muestran los deseos cumplidos de {{name}}",
        titleOtherProfile: "Perfil del usuario",
        settings: "Configuración",
        birthday: "Cumpleaños",
        actionFillBirthday: "Indicar",
        findFriends: "Encontrar listas de deseos de amigos",
      },
      settings: {
        profileData: "Datos del perfil",
        bookedWishes: "Deseos reservados",
        hideBookings: {
          value: "Ocultar",
          description: "No verás si alguien ha reservado tus deseos",
        },
        anonymousBookings: {
          value: "Mostrar anónimamente",
          description: "Verás si alguien ha reservado tus deseos",
        },
        publicBookings: {
          value: "Mostrar nombres",
          description: "Verás los nombres de quienes han reservado tus deseos",
        },
        giftedWishesVisibility: {
          value: "Mostrar cumplidos",
          description: "Otros usuarios verán tu sección de deseos cumplidos",
          visibleDescription: "Los visitantes de tu perfil ven esta sección. Puedes cambiarlo en",
          hiddenDescription: "Los visitantes de tu perfil no ven esta sección. Puedes cambiarlo en",
          settingsLink: "configuración",
        },
        tgUsernameVisibility: {
          value: "Mostrar username de Telegram",
          description: "Tu dirección pública se mostrará en el perfil",
          disabledDescription: "No tienes una dirección pública en telegram",
        },
      },
      action: {
        apply: "Aplicar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        clear: "Limpiar",
        save: "Guardar",
        add: "Añadir",
        subscribe: "Suscribirse",
        unsubscribe: "Cancelar suscripción",
        share: "Compartir",
        shareProfile: "Compartir perfil",
        selectPhoto: "Seleccionar foto",
        reorder: "Reordenar",
      },
      wish: {
        wishes: "Deseos",
        action: {
          add: "Añadir deseo",
          delete: "Eliminar deseo",
          book: "Reservar",
          cancelBooking: "Cancelar reserva",
          openLink: "Abrir enlace",
          edit: "Editar deseo",
          addToWishlists: "Añadir a listas de deseos",
          copyWish: "Copiar deseo",
        },
        dialog: {
          delete: {
            title: "Eliminar deseo",
            text: "¿Estás seguro de que quieres eliminar este deseo?",
          },
          confirmHiddenBooking: "Has ocultado la visualización de reservas en la configuración. Este deseo puede estar reservado por alguien. ¿Estás seguro de que quieres continuar?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Título (obligatorio)",
          price: "Precio",
          url: "Enlace (https://example.com...)",
          description: "Comentario / Descripción",
        },
        gifted: {
          action: "Cumplido",
          previewLabel: "Deseo",
          date: "Fecha de cumplimiento",
          withoutDate: "Sin fecha",
          comment: "Comentario",
          editDescription: "Editar descripción",
          showGiftedBy: "Mostrar quién lo cumplió",
          showGiftedByNotificationHint: "Si está activado, quien lo reservó recibirá una notificación de que se movió a cumplidos con tu comentario.",
          showGiftedByHint: "Si en realidad lo cumplió otra persona, recomendamos desactivar esta opción",
          confirmShowGiftedBy: "¿Seguro que quieres ver quién reservó este deseo?",
          giftFrom: "Regalo de",
          giftToSelf: "Regalo para ti",
          notLoaded: "Deseo no cargado",
        },
        alreadyBooked: "(ya reservado)",
        alreadyBookedMessage: "Este deseo ya ha sido reservado por alguien",
        booked: "Reservado",
        bookedBy: "Reservado por:",
        bookedByYou: "Reservado por ti",
        alreadyCopied: "Copiado a tus deseos",
        name: {
          empty: "No hay deseos",
          one: "deseo",
          few: "deseos",
          many: "deseos",
        }
      },
      idea: {
        added: "Deseo añadido",
        apply: "Añadir a tus deseos",
        hide: "Ocultar idea",
        shouldHide: "¿Quieres ocultar esta idea? Ya no se mostrará en la lista de ideas",
      },
      wishlist: {
        action: {
          delete: "Eliminar lista de deseos",
          create: "Crear lista de deseos",
          edit: "Editar lista de deseos",
          selectCover: "Seleccionar portada",
        },
        dialog: {
          delete: {
            title: "Eliminar lista de deseos",
            text: "¿Estás seguro de que quieres eliminar esta lista de deseos?",
          },
        },
        placeholder: {
          title: "Título (obligatorio)",
          description: "Descripción",
        },
      },
      privacy: {
        title: "Privacidad",
        public: {
          title: "Público",
          description: "Visible en tu perfil",
          shortDescription: "Visible para todos",
        },
        link: {
          title: "Por enlace",
          description: "Visible para todos los que tengan el enlace",
          shortDescription: "Visible por enlace",
        },
        private: {
          title: "Privado",
          description: "Visible solo para quienes permitas",
          shortDescription: "Visible con permiso",
        },
      },
      system: {
        birthdaySaved: "Cumpleaños guardado",
        unknowError: "Ha ocurrido un error desconocido. Inténtalo de nuevo",
        emptyTitle: "El título no puede estar vacío",
        invalidUrl: "Formato de enlace no válido. Usa un enlace como \"https://...\"",
        wishDeleted: "Deseo eliminado",
        wishGifted: "Deseo movido a cumplidos",
        wishlistDeleted: "Lista de deseos eliminada",
        wishlistSubscribed: "Lista de deseos añadida a suscripciones",
        wishlistUnsubscribed: "Lista de deseos eliminada de suscripciones",
        settingsSaved: "Configuración guardada",
        telegramChannelLinkText: "Canal de Telegram del servicio:",
        reorderSaveFailed: "Error al guardar el orden de los deseos. Inténtalo de nuevo",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Crear"
      },
      secretSanta: {
        title: "Amigo Invisible",
        myGames: "Mis juegos",
        create: "Crear juego",
        organizer: "Organizador",
        participant: "Participante",
        status: {
          open: "Abierto",
          drawn: "Sorteo realizado",
          completed: "Completado"
        },
        warning: {
          title: "Serás el organizador",
          description: "Serás responsable de dirigir el juego",
          responsibility1: "Invitar participantes",
          responsibility2: "Iniciar el sorteo cuando todos estén listos",
          responsibility3: "Gestionar el evento",
          confirm: "Entendido, crear juego",
        },
        form: {
          title: "Título del juego",
          description: "Descripción",
          budget: "Presupuesto del regalo",
          eventDate: "Fecha del evento",
          coverImage: "Imagen de portada",
          selectCurrency: "Seleccionar moneda"
        },
        share: {
          title: "¡Juego creado!",
          description: "Comparte el enlace con los participantes",
          copyLink: "Copiar enlace",
          shareVia: "Compartir",
          done: "Listo",
          linkCopied: "Enlace copiado",
          shareText: "¡Únete al grupo de Amigo Invisible!"
        },
        participants: {
          title: "Participantes",
          count: "Participantes: {{count}}",
          join: "Unirse",
          leave: "Salir del juego",
          youParticipate: "Participas",
          edit: "Editar información",
          kickParticipant: "Expulsar participante"
        },
        join: {
          title: "Unirse al juego",
          displayName: "Tu nombre en el juego",
          selectWishlist: "Seleccionar lista de deseos",
          preferences: "Tus preferencias (opcional)",
          submit: "Unirse",
          wishlist_for_santa: "Lista de deseos para Santa"
        },
        assignment: {
          title: "Tu destinatario",
          viewWishlist: "Ver lista de deseos",
          preferences: "Preferencias",
          noPreferences: "Sin preferencias especificadas"
        },
        messages: {
          title: "Mensajes",
          placeholder: "Escribir mensaje...",
          send: "Enviar",
          emptyState: "Inicia una conversación con tu Amigo Invisible",
          secretSanta: "Amigo Invisible"
        },
        actions: {
          edit: "Editar",
          startDraw: "Iniciar sorteo",
          share: "Compartir enlace",
          delete: "Eliminar juego",
          organizerActions: "Acciones del organizador"
        },
        error: {
          createFailed: "Error al crear juego",
          joinFailed: "Error al unirse",
          drawFailed: "Error al iniciar sorteo",
          insufficientParticipants: "Participantes insuficientes (mínimo 3)",
          alreadyJoined: "Ya participas en este juego",
          notOpen: "Juego cerrado para nuevos participantes",
          messageFailed: "Error al enviar mensaje",
          loadFailed: "Error al cargar juego",
          leaveFailed: "Error al salir del juego",
          updateFailed: "Error al actualizar información"
        },
        emptyState: {
          noGames: "Aún no tienes juegos",
          createFirst: "Crea tu primer juego de Amigo Invisible",
          noParticipants: "Invita participantes",
          waitingForDraw: "Esperando sorteo"
        },
        dialog: {
          leaveConfirm: "¿Estás seguro de que quieres salir del juego?",
          deleteConfirm: "¿Estás seguro de que quieres eliminar el juego?",
          kickConfirm: "¿Estás seguro de que quieres expulsar a este participante del juego?",
          drawConfirm: "¿Estás seguro de que quieres iniciar el sorteo? Después de esto, los participantes recibirán información sobre sus destinatarios. La edición de información y participantes se volverá no disponible."
        }
      },
    }
  },
  fr: {
    translation: {
      navigation: {
        main: "Principal",
        toMain: "Vers l'accueil",
        allWishes: "Tous les souhaits",
      },
      state: {
        unknownError: "Une erreur inconnue s'est produite. Nous avons déjà reçu une notification et corrigerons bientôt tout",
        temporaryUnavailable: "Le service est temporairement indisponible. Veuillez réessayer plus tard",
        wishlistNotFound: "Liste de souhaits introuvable ou supprimée",
        noSubscribes: "Les listes de souhaits auxquelles vous vous abonnez s'afficheront ici",
        noPublicWishlists: "Il n'y a pas encore de listes de souhaits publiques",
        emptyWishes: "Il n'y a pas encore de souhaits",
        emptyGiftedWishes: "Il n'y a pas encore de souhaits marqués comme exaucés",
      },
      profile: {
        titleYourProfile: "Votre profil",
        titleYourWishlists: "Vos listes de souhaits",
        titleUserWishlists: "Listes de souhaits de l'utilisateur",
        subscribes: "Abonnements",
        allYourWishes: "Tous vos souhaits",
        giftedWishes: "Souhaits exaucés",
        yourGiftedWishesDescription: "Vos souhaits exaucés s'affichent ici",
        userGiftedWishesDescription: "Les souhaits exaucés de {{name}} s'affichent ici",
        titleOtherProfile: "Profil de l'utilisateur",
        settings: "Paramètres",
        birthday: "Anniversaire",
        actionFillBirthday: "Remplir",
        findFriends: "Trouver les listes de souhaits des amis",
      },
      settings: {
        profileData: "Données du profil",
        bookedWishes: "Souhaits réservés",
        hideBookings: {
          value: "Masquer",
          description: "Vous ne verrez pas si quelqu'un a réservé vos souhaits",
        },
        anonymousBookings: {
          value: "Afficher anonymement",
          description: "Vous verrez si quelqu'un a réservé vos souhaits",
        },
        publicBookings: {
          value: "Afficher les noms",
          description: "Vous verrez les noms de ceux qui ont réservé vos souhaits",
        },
        giftedWishesVisibility: {
          value: "Afficher les souhaits exaucés",
          description: "Les autres utilisateurs verront votre section de souhaits exaucés",
          visibleDescription: "Les visiteurs de votre profil voient cette section. Vous pouvez modifier cela dans les",
          hiddenDescription: "Les visiteurs de votre profil ne voient pas cette section. Vous pouvez modifier cela dans les",
          settingsLink: "paramètres",
        },
        tgUsernameVisibility: {
          value: "Afficher le username Telegram",
          description: "Votre adresse publique sera affichée dans le profil",
          disabledDescription: "Vous n'avez pas d'adresse publique sur telegram",
        },
      },
      action: {
        apply: "Appliquer",
        cancel: "Annuler",
        edit: "Modifier",
        delete: "Supprimer",
        clear: "Effacer",
        save: "Enregistrer",
        add: "Ajouter",
        subscribe: "S'abonner",
        unsubscribe: "Se désabonner",
        share: "Partager",
        shareProfile: "Partager le profil",
        selectPhoto: "Sélectionner une photo",
        reorder: "Réorganiser",
      },
      wish: {
        wishes: "Souhaits",
        action: {
          add: "Ajouter un souhait",
          delete: "Supprimer le souhait",
          book: "Réserver",
          cancelBooking: "Annuler la réservation",
          openLink: "Ouvrir le lien",
          edit: "Modifier le souhait",
          addToWishlists: "Ajouter aux listes de souhaits",
          copyWish: "Copier le souhait",
        },
        dialog: {
          delete: {
            title: "Supprimer le souhait",
            text: "Êtes-vous sûr de vouloir supprimer ce souhait ?",
          },
          confirmHiddenBooking: "Vous avez masqué l'affichage des réservations dans les paramètres. Ce souhait peut être réservé par quelqu'un. Êtes-vous sûr de vouloir continuer ?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Titre (obligatoire)",
          price: "Prix",
          url: "Lien (https://example.com...)",
          description: "Commentaire / Description",
        },
        gifted: {
          action: "Exaucé",
          previewLabel: "Souhait",
          date: "Date d'exaucement",
          withoutDate: "Sans date",
          comment: "Commentaire",
          editDescription: "Modifier la description",
          showGiftedBy: "Afficher qui l'a exaucé",
          showGiftedByNotificationHint: "Si cette option est activée, la personne qui l'a réservé recevra une notification indiquant qu'il a été déplacé dans les souhaits exaucés avec votre commentaire.",
          showGiftedByHint: "Si le souhait a en fait été exaucé par quelqu'un d'autre, nous vous recommandons de désactiver cette option",
          confirmShowGiftedBy: "Voulez-vous vraiment voir qui a réservé ce souhait ?",
          giftFrom: "Cadeau de",
          giftToSelf: "Cadeau pour vous-même",
          notLoaded: "Souhait non chargé",
        },
        alreadyBooked: "(déjà réservé)",
        alreadyBookedMessage: "Ce souhait est déjà réservé par quelqu'un",
        booked: "Réservé",
        bookedBy: "Réservé par :",
        bookedByYou: "Réservé par vous",
        alreadyCopied: "Copié dans vos souhaits",
        name: {
          empty: "Pas de souhaits",
          one: "souhait",
          few: "souhaits",
          many: "souhaits",
        }
      },
      idea: {
        added: "Souhait ajouté",
        apply: "Ajouter à vos souhaits",
        hide: "Masquer l'idée",
        shouldHide: "Voulez-vous masquer cette idée ? Elle ne sera plus affichée dans la liste des idées",
      },
      wishlist: {
        action: {
          delete: "Supprimer la liste de souhaits",
          create: "Créer une liste de souhaits",
          edit: "Modifier la liste de souhaits",
          selectCover: "Sélectionner la couverture",
        },
        dialog: {
          delete: {
            title: "Supprimer la liste de souhaits",
            text: "Êtes-vous sûr de vouloir supprimer cette liste de souhaits ?",
          },
        },
        placeholder: {
          title: "Titre (obligatoire)",
          description: "Description",
        },
      },
      privacy: {
        title: "Confidentialité",
        public: {
          title: "Public",
          description: "Visible sur votre profil",
          shortDescription: "Visible par tous",
        },
        link: {
          title: "Par lien",
          description: "Visible par tous ceux qui ont le lien",
          shortDescription: "Visible par lien",
        },
        private: {
          title: "Privé",
          description: "Visible uniquement par ceux que vous autorisez",
          shortDescription: "Visible sur autorisation",
        },
      },
      system: {
        birthdaySaved: "Anniversaire enregistré",
        unknowError: "Une erreur inconnue s'est produite. Veuillez réessayer",
        emptyTitle: "Le titre ne peut pas être vide",
        invalidUrl: "Format de lien invalide. Utilisez un lien comme \"https://...\"",
        wishDeleted: "Souhait supprimé",
        wishGifted: "Souhait déplacé vers les réalisés",
        wishlistDeleted: "Liste de souhaits supprimée",
        wishlistSubscribed: "Liste de souhaits ajoutée aux abonnements",
        wishlistUnsubscribed: "Liste de souhaits retirée des abonnements",
        settingsSaved: "Paramètres enregistrés",
        telegramChannelLinkText: "Canal Telegram du service :",
        reorderSaveFailed: "Échec de la sauvegarde de l'ordre des souhaits. Veuillez réessayer",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Créer"
      },
      secretSanta: {
        title: "Père Noël Secret",
        myGames: "Mes jeux",
        create: "Créer un jeu",
        organizer: "Organisateur",
        participant: "Participant",
        status: {
          open: "Ouvert",
          drawn: "Tirage effectué",
          completed: "Terminé"
        },
        warning: {
          title: "Vous serez l'organisateur",
          description: "Vous serez responsable de la gestion du jeu",
          responsibility1: "Inviter des participants",
          responsibility2: "Lancer le tirage quand tout le monde est prêt",
          responsibility3: "Gérer l'événement",
          confirm: "Compris, créer le jeu",
        },
        form: {
          title: "Titre du jeu",
          description: "Description",
          budget: "Budget du cadeau",
          eventDate: "Date de l'événement",
          coverImage: "Image de couverture",
          selectCurrency: "Sélectionner la devise"
        },
        share: {
          title: "Jeu créé !",
          description: "Partagez le lien avec les participants",
          copyLink: "Copier le lien",
          shareVia: "Partager",
          done: "Terminé",
          linkCopied: "Lien copié",
          shareText: "Rejoignez le groupe Père Noël Secret !"
        },
        participants: {
          title: "Participants",
          count: "Participants : {{count}}",
          join: "Rejoindre",
          leave: "Quitter le jeu",
          youParticipate: "Vous participez",
          edit: "Modifier les infos",
          kickParticipant: "Expulser le participant"
        },
        join: {
          title: "Rejoindre le jeu",
          displayName: "Votre nom dans le jeu",
          selectWishlist: "Sélectionner une liste de souhaits",
          preferences: "Vos préférences (facultatif)",
          submit: "Rejoindre",
          wishlist_for_santa: "Liste de souhaits pour le Père Noël"
        },
        assignment: {
          title: "Votre destinataire",
          viewWishlist: "Voir la liste de souhaits",
          preferences: "Préférences",
          noPreferences: "Aucune préférence spécifiée"
        },
        messages: {
          title: "Messages",
          placeholder: "Écrire un message...",
          send: "Envoyer",
          emptyState: "Commencez une conversation avec votre Père Noël Secret",
          secretSanta: "Père Noël Secret"
        },
        actions: {
          edit: "Modifier",
          startDraw: "Lancer le tirage",
          share: "Partager le lien",
          delete: "Supprimer le jeu",
          organizerActions: "Actions de l'organisateur"
        },
        error: {
          createFailed: "Échec de la création du jeu",
          joinFailed: "Échec de la participation",
          drawFailed: "Échec du lancement du tirage",
          insufficientParticipants: "Participants insuffisants (minimum 3)",
          alreadyJoined: "Vous participez déjà à ce jeu",
          notOpen: "Jeu fermé aux nouveaux participants",
          messageFailed: "Échec de l'envoi du message",
          loadFailed: "Échec du chargement du jeu",
          leaveFailed: "Échec de la sortie du jeu",
          updateFailed: "Échec de la mise à jour des infos"
        },
        emptyState: {
          noGames: "Vous n'avez pas encore de jeux",
          createFirst: "Créez votre premier jeu de Père Noël Secret",
          noParticipants: "Invitez des participants",
          waitingForDraw: "En attente du tirage"
        },
        dialog: {
          leaveConfirm: "Êtes-vous sûr de vouloir quitter le jeu ?",
          deleteConfirm: "Êtes-vous sûr de vouloir supprimer le jeu ?",
          kickConfirm: "Êtes-vous sûr de vouloir expulser ce participant du jeu ?",
          drawConfirm: "Êtes-vous sûr de vouloir lancer le tirage ? Après cela, les participants recevront des informations sur leurs destinataires. La modification des informations et des participants deviendra indisponible."
        }
      },
    }
  },
  it: {
    translation: {
      navigation: {
        main: "Principale",
        toMain: "Alla pagina principale",
        allWishes: "Tutti i desideri",
      },
      state: {
        unknownError: "Si è verificato un errore sconosciuto. Abbiamo già ricevuto una notifica e sistemeremo tutto presto",
        temporaryUnavailable: "Il servizio è temporaneamente non disponibile. Riprova più tardi",
        wishlistNotFound: "Lista dei desideri non trovata o eliminata",
        noSubscribes: "Qui verranno visualizzate le liste dei desideri a cui ti sei iscritto",
        noPublicWishlists: "Non ci sono ancora liste dei desideri pubbliche",
        emptyWishes: "Non ci sono ancora desideri",
        emptyGiftedWishes: "Non ci sono ancora desideri contrassegnati come esauditi",
      },
      profile: {
        titleYourProfile: "Il tuo profilo",
        titleYourWishlists: "Le tue liste dei desideri",
        titleUserWishlists: "Liste dei desideri dell'utente",
        subscribes: "Iscrizioni",
        allYourWishes: "Tutti i tuoi desideri",
        giftedWishes: "Desideri esauditi",
        yourGiftedWishesDescription: "Qui vengono mostrati i tuoi desideri esauditi",
        userGiftedWishesDescription: "Qui vengono mostrati i desideri esauditi di {{name}}",
        titleOtherProfile: "Profilo utente",
        settings: "Impostazioni",
        birthday: "Compleanno",
        actionFillBirthday: "Inserisci",
        findFriends: "Trova liste dei desideri degli amici",
      },
      settings: {
        profileData: "Dati del profilo",
        bookedWishes: "Desideri prenotati",
        hideBookings: {
          value: "Nascondi",
          description: "Non vedrai se qualcuno ha prenotato i tuoi desideri",
        },
        anonymousBookings: {
          value: "Mostra in modo anonimo",
          description: "Vedrai se qualcuno ha prenotato i tuoi desideri",
        },
        publicBookings: {
          value: "Mostra i nomi",
          description: "Vedrai i nomi di chi ha prenotato i tuoi desideri",
        },
        giftedWishesVisibility: {
          value: "Mostra esauditi",
          description: "Gli altri utenti vedranno la tua sezione dei desideri esauditi",
          visibleDescription: "I visitatori del tuo profilo vedono questa sezione. Puoi modificarlo nelle",
          hiddenDescription: "I visitatori del tuo profilo non vedono questa sezione. Puoi modificarlo nelle",
          settingsLink: "impostazioni",
        },
        tgUsernameVisibility: {
          value: "Mostra username Telegram",
          description: "Il tuo indirizzo pubblico sarà mostrato nel profilo",
          disabledDescription: "Non hai un indirizzo pubblico su telegram",
        },
      },
      action: {
        apply: "Applica",
        cancel: "Annulla",
        edit: "Modifica",
        delete: "Elimina",
        clear: "Cancella",
        save: "Salva",
        add: "Aggiungi",
        subscribe: "Iscriviti",
        unsubscribe: "Annulla iscrizione",
        share: "Condividi",
        shareProfile: "Condividi profilo",
        selectPhoto: "Seleziona foto",
        reorder: "Riordina",
      },
      wish: {
        wishes: "Desideri",
        action: {
          add: "Aggiungi desiderio",
          delete: "Elimina desiderio",
          book: "Prenota",
          cancelBooking: "Annulla prenotazione",
          openLink: "Apri link",
          edit: "Modifica desiderio",
          addToWishlists: "Aggiungi alle liste dei desideri",
          copyWish: "Copia desiderio",
        },
        dialog: {
          delete: {
            title: "Elimina desiderio",
            text: "Sei sicuro di voler eliminare questo desiderio?",
          },
          confirmHiddenBooking: "Hai nascosto la visualizzazione delle prenotazioni nelle impostazioni. Questo desiderio potrebbe essere stato prenotato da qualcuno. Sei sicuro di voler continuare?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Titolo (obbligatorio)",
          price: "Prezzo",
          url: "Link (https://example.com...)",
          description: "Commento / Descrizione",
        },
        gifted: {
          action: "Esaudito",
          previewLabel: "Desiderio",
          date: "Data di esaudimento",
          withoutDate: "Senza data",
          comment: "Commento",
          editDescription: "Modifica descrizione",
          showGiftedBy: "Mostra chi lo ha esaudito",
          showGiftedByNotificationHint: "Se attivato, chi lo ha prenotato riceverà una notifica che è stato spostato tra gli esauditi con il tuo commento.",
          showGiftedByHint: "Se in realtà il desiderio è stato esaudito da un'altra persona, consigliamo di disattivare questa opzione",
          confirmShowGiftedBy: "Vuoi davvero vedere chi ha prenotato questo desiderio?",
          giftFrom: "Regalo da",
          giftToSelf: "Regalo a te stesso",
          notLoaded: "Desiderio non caricato",
        },
        alreadyBooked: "(già prenotato)",
        alreadyBookedMessage: "Questo desiderio è già stato prenotato da qualcuno",
        booked: "Prenotato",
        bookedBy: "Prenotato da:",
        bookedByYou: "Prenotato da te",
        alreadyCopied: "Copiato nei tuoi desideri",
        name: {
          empty: "Nessun desiderio",
          one: "desiderio",
          few: "desideri",
          many: "desideri",
        }
      },
      idea: {
        added: "Desiderio aggiunto",
        apply: "Aggiungi ai tuoi desideri",
        hide: "Nascondi idea",
        shouldHide: "Vuoi nascondere questa idea? Non verrà più mostrata nell'elenco delle idee",
      },
      wishlist: {
        action: {
          delete: "Elimina lista dei desideri",
          create: "Crea lista dei desideri",
          edit: "Modifica lista dei desideri",
          selectCover: "Seleziona copertina",
        },
        dialog: {
          delete: {
            title: "Elimina lista dei desideri",
            text: "Sei sicuro di voler eliminare questa lista dei desideri?",
          },
        },
        placeholder: {
          title: "Titolo (obbligatorio)",
          description: "Descrizione",
        },
      },
      privacy: {
        title: "Privacy",
        public: {
          title: "Pubblico",
          description: "Visibile nel tuo profilo",
          shortDescription: "Visibile a tutti",
        },
        link: {
          title: "Tramite link",
          description: "Visibile a tutti coloro che hanno il link",
          shortDescription: "Visibile tramite link",
        },
        private: {
          title: "Privato",
          description: "Visibile solo a chi autorizzi",
          shortDescription: "Visibile con autorizzazione",
        },
      },
      system: {
        birthdaySaved: "Compleanno salvato",
        unknowError: "Si è verificato un errore sconosciuto. Riprova",
        emptyTitle: "Il titolo non può essere vuoto",
        invalidUrl: "Formato del link non valido. Usa un link come \"https://...\"",
        wishDeleted: "Desiderio eliminato",
        wishGifted: "Desiderio spostato tra quelli realizzati",
        wishlistDeleted: "Lista dei desideri eliminata",
        wishlistSubscribed: "Lista dei desideri aggiunta alle iscrizioni",
        wishlistUnsubscribed: "Lista dei desideri rimossa dalle iscrizioni",
        settingsSaved: "Impostazioni salvate",
        telegramChannelLinkText: "Canale Telegram del servizio:",
        reorderSaveFailed: "Impossibile salvare l'ordine dei desideri. Riprova",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Crea"
      },
      secretSanta: {
        title: "Babbo Natale Segreto",
        myGames: "I miei giochi",
        create: "Crea gioco",
        organizer: "Organizzatore",
        participant: "Partecipante",
        status: {
          open: "Aperto",
          drawn: "Sorteggio effettuato",
          completed: "Completato"
        },
        warning: {
          title: "Sarai l'organizzatore",
          description: "Sarai responsabile della gestione del gioco",
          responsibility1: "Invitare partecipanti",
          responsibility2: "Avviare il sorteggio quando tutti sono pronti",
          responsibility3: "Gestire l'evento",
          confirm: "Capito, crea gioco",
        },
        form: {
          title: "Titolo del gioco",
          description: "Descrizione",
          budget: "Budget del regalo",
          eventDate: "Data dell'evento",
          coverImage: "Immagine di copertina",
          selectCurrency: "Seleziona valuta"
        },
        share: {
          title: "Gioco creato!",
          description: "Condividi il link con i partecipanti",
          copyLink: "Copia link",
          shareVia: "Condividi",
          done: "Fatto",
          linkCopied: "Link copiato",
          shareText: "Partecipa al gruppo Babbo Natale Segreto!"
        },
        participants: {
          title: "Partecipanti",
          count: "Partecipanti: {{count}}",
          join: "Unisciti",
          leave: "Lascia il gioco",
          youParticipate: "Partecipi",
          edit: "Modifica info",
          kickParticipant: "Espelli partecipante"
        },
        join: {
          title: "Unisciti al gioco",
          displayName: "Il tuo nome nel gioco",
          selectWishlist: "Seleziona lista dei desideri",
          preferences: "Le tue preferenze (facoltativo)",
          submit: "Unisciti",
          wishlist_for_santa: "Lista dei desideri per Babbo Natale"
        },
        assignment: {
          title: "Il tuo destinatario",
          viewWishlist: "Vedi lista dei desideri",
          preferences: "Preferenze",
          noPreferences: "Nessuna preferenza specificata"
        },
        messages: {
          title: "Messaggi",
          placeholder: "Scrivi un messaggio...",
          send: "Invia",
          emptyState: "Inizia una conversazione con il tuo Babbo Natale Segreto",
          secretSanta: "Babbo Natale Segreto"
        },
        actions: {
          edit: "Modifica",
          startDraw: "Avvia sorteggio",
          share: "Condividi link",
          delete: "Elimina gioco",
          organizerActions: "Azioni organizzatore"
        },
        error: {
          createFailed: "Creazione gioco fallita",
          joinFailed: "Partecipazione fallita",
          drawFailed: "Avvio sorteggio fallito",
          insufficientParticipants: "Partecipanti insufficienti (minimo 3)",
          alreadyJoined: "Partecipi già a questo gioco",
          notOpen: "Gioco chiuso a nuovi partecipanti",
          messageFailed: "Invio messaggio fallito",
          loadFailed: "Caricamento gioco fallito",
          leaveFailed: "Uscita dal gioco fallita",
          updateFailed: "Aggiornamento info fallito"
        },
        emptyState: {
          noGames: "Non hai ancora giochi",
          createFirst: "Crea il tuo primo gioco di Babbo Natale Segreto",
          noParticipants: "Invita partecipanti",
          waitingForDraw: "In attesa del sorteggio"
        },
        dialog: {
          leaveConfirm: "Sei sicuro di voler lasciare il gioco?",
          deleteConfirm: "Sei sicuro di voler eliminare il gioco?",
          kickConfirm: "Sei sicuro di voler espellere questo partecipante dal gioco?",
          drawConfirm: "Sei sicuro di voler avviare il sorteggio? Dopo di che, i partecipanti riceveranno informazioni sui loro destinatari. La modifica delle informazioni e dei partecipanti diventerà non disponibile."
        }
      },
    }
  },
  de: {
    translation: {
      navigation: {
        main: "Hauptseite",
        toMain: "Zur Hauptseite",
        allWishes: "Alle Wünsche",
      },
      state: {
        unknownError: "Ein unbekannter Fehler ist aufgetreten. Wir haben bereits eine Benachrichtigung erhalten und werden alles bald beheben",
        temporaryUnavailable: "Der Service ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut",
        wishlistNotFound: "Wunschliste nicht gefunden oder gelöscht",
        noSubscribes: "Hier werden die Wunschlisten angezeigt, die Sie abonniert haben",
        noPublicWishlists: "Es gibt noch keine öffentlichen Wunschlisten",
        emptyWishes: "Es gibt noch keine Wünsche",
        emptyGiftedWishes: "Es gibt noch keine als erfüllt markierten Wünsche",
      },
      profile: {
        titleYourProfile: "Ihr Profil",
        titleYourWishlists: "Ihre Wunschlisten",
        titleUserWishlists: "Wunschlisten des Benutzers",
        subscribes: "Abonnements",
        allYourWishes: "Alle Ihre Wünsche",
        giftedWishes: "Erfüllte Wünsche",
        yourGiftedWishesDescription: "Ihre erfüllten Wünsche werden hier angezeigt",
        userGiftedWishesDescription: "Die erfüllten Wünsche von {{name}} werden hier angezeigt",
        titleOtherProfile: "Benutzerprofil",
        settings: "Einstellungen",
        birthday: "Geburtstag",
        actionFillBirthday: "Eingeben",
        findFriends: "Wunschlisten von Freunden finden",
      },
      settings: {
        profileData: "Profildaten",
        bookedWishes: "Reservierte Wünsche",
        hideBookings: {
          value: "Ausblenden",
          description: "Sie sehen nicht, wenn jemand Ihre Wünsche reserviert hat",
        },
        anonymousBookings: {
          value: "Anonym anzeigen",
          description: "Sie sehen, wenn jemand Ihre Wünsche reserviert hat",
        },
        publicBookings: {
          value: "Namen anzeigen",
          description: "Sie sehen die Namen derjenigen, die Ihre Wünsche reserviert haben",
        },
        giftedWishesVisibility: {
          value: "Erfüllte anzeigen",
          description: "Andere Benutzer sehen Ihren Bereich mit erfüllten Wünschen",
          visibleDescription: "Besucher Ihres Profils sehen diesen Bereich. Sie können dies in den",
          hiddenDescription: "Besucher Ihres Profils sehen diesen Bereich nicht. Sie können dies in den",
          settingsLink: "Einstellungen",
        },
        tgUsernameVisibility: {
          value: "Telegram-Username anzeigen",
          description: "Ihre öffentliche Adresse wird im Profil angezeigt",
          disabledDescription: "Sie haben keine öffentliche Adresse in telegram",
        },
      },
      action: {
        apply: "Anwenden",
        cancel: "Abbrechen",
        edit: "Bearbeiten",
        delete: "Löschen",
        clear: "Leeren",
        save: "Speichern",
        add: "Hinzufügen",
        subscribe: "Abonnieren",
        unsubscribe: "Abonnement beenden",
        share: "Teilen",
        shareProfile: "Profil teilen",
        selectPhoto: "Foto auswählen",
        reorder: "Neu ordnen",
      },
      wish: {
        wishes: "Wünsche",
        action: {
          add: "Wunsch hinzufügen",
          delete: "Wunsch löschen",
          book: "Reservieren",
          cancelBooking: "Reservierung stornieren",
          openLink: "Link öffnen",
          edit: "Wunsch bearbeiten",
          addToWishlists: "Zu Wunschlisten hinzufügen",
          copyWish: "Wunsch kopieren",
        },
        dialog: {
          delete: {
            title: "Wunsch löschen",
            text: "Sind Sie sicher, dass Sie diesen Wunsch löschen möchten?",
          },
          confirmHiddenBooking: "Sie haben die Anzeige von Reservierungen in den Einstellungen ausgeblendet. Dieser Wunsch könnte von jemandem reserviert sein. Sind Sie sicher, dass Sie fortfahren möchten?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Titel (erforderlich)",
          price: "Preis",
          url: "Link (https://example.com...)",
          description: "Kommentar / Beschreibung",
        },
        gifted: {
          action: "Erfüllt",
          previewLabel: "Wunsch",
          date: "Erfüllt am",
          withoutDate: "Ohne Datum",
          comment: "Kommentar",
          editDescription: "Beschreibung bearbeiten",
          showGiftedBy: "Anzeigen, wer ihn erfüllt hat",
          showGiftedByNotificationHint: "Wenn aktiviert, erhält die Person, die ihn reserviert hat, eine Benachrichtigung, dass er mit Ihrem Kommentar zu den erfüllten Wünschen verschoben wurde.",
          showGiftedByHint: "Wenn der Wunsch tatsächlich von jemand anderem erfüllt wurde, empfehlen wir, diese Option zu deaktivieren",
          confirmShowGiftedBy: "Möchten Sie wirklich sehen, wer diesen Wunsch reserviert hat?",
          giftFrom: "Geschenk von",
          giftToSelf: "Geschenk an sich selbst",
          notLoaded: "Wunsch nicht geladen",
        },
        alreadyBooked: "(bereits reserviert)",
        alreadyBookedMessage: "Dieser Wunsch ist bereits von jemandem reserviert",
        booked: "Reserviert",
        bookedBy: "Reserviert von:",
        bookedByYou: "Von Ihnen reserviert",
        alreadyCopied: "In Ihre Wünsche kopiert",
        name: {
          empty: "Keine Wünsche",
          one: "Wunsch",
          few: "Wünsche",
          many: "Wünsche",
        }
      },
      idea: {
        added: "Wunsch hinzugefügt",
        apply: "Zu deinen Wünschen hinzufügen",
        hide: "Idee ausblenden",
        shouldHide: "Möchtest du diese Idee ausblenden? Sie wird nicht mehr in der Ideenliste angezeigt",
      },
      wishlist: {
        action: {
          delete: "Wunschliste löschen",
          create: "Wunschliste erstellen",
          edit: "Wunschliste bearbeiten",
          selectCover: "Cover auswählen",
        },
        dialog: {
          delete: {
            title: "Wunschliste löschen",
            text: "Sind Sie sicher, dass Sie diese Wunschliste löschen möchten?",
          },
        },
        placeholder: {
          title: "Titel (erforderlich)",
          description: "Beschreibung",
        },
      },
      privacy: {
        title: "Datenschutz",
        public: {
          title: "Öffentlich",
          description: "Sichtbar in Ihrem Profil",
          shortDescription: "Für alle sichtbar",
        },
        link: {
          title: "Per Link",
          description: "Sichtbar für alle mit dem Link",
          shortDescription: "Per Link sichtbar",
        },
        private: {
          title: "Privat",
          description: "Nur für von Ihnen zugelassene Personen sichtbar",
          shortDescription: "Mit Erlaubnis sichtbar",
        },
      },
      system: {
        birthdaySaved: "Geburtstag gespeichert",
        unknowError: "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut",
        emptyTitle: "Der Titel darf nicht leer sein",
        invalidUrl: "Ungültiges Link-Format. Verwenden Sie einen Link wie \"https://...\"",
        wishDeleted: "Wunsch gelöscht",
        wishGifted: "Wunsch zu erfüllt verschoben",
        wishlistDeleted: "Wunschliste gelöscht",
        wishlistSubscribed: "Wunschliste zu Abonnements hinzugefügt",
        wishlistUnsubscribed: "Wunschliste aus Abonnements entfernt",
        settingsSaved: "Einstellungen gespeichert",
        telegramChannelLinkText: "Telegram-Kanal des Dienstes:",
        reorderSaveFailed: "Fehler beim Speichern der Wunschreihenfolge. Bitte versuchen Sie es erneut",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Erstellen"
      },
      secretSanta: {
        title: "Wichteln",
        myGames: "Meine Spiele",
        create: "Spiel erstellen",
        organizer: "Organisator",
        participant: "Teilnehmer",
        status: {
          open: "Offen",
          drawn: "Auslosung durchgeführt",
          completed: "Abgeschlossen"
        },
        warning: {
          title: "Sie werden der Organisator sein",
          description: "Sie sind für die Durchführung des Spiels verantwortlich",
          responsibility1: "Teilnehmer einladen",
          responsibility2: "Auslosung starten, wenn alle bereit sind",
          responsibility3: "Veranstaltung verwalten",
          confirm: "Verstanden, Spiel erstellen",
        },
        form: {
          title: "Spieltitel",
          description: "Beschreibung",
          budget: "Geschenkbudget",
          eventDate: "Veranstaltungsdatum",
          coverImage: "Titelbild",
          selectCurrency: "Währung auswählen"
        },
        share: {
          title: "Spiel erstellt!",
          description: "Teilen Sie den Link mit den Teilnehmern",
          copyLink: "Link kopieren",
          shareVia: "Teilen",
          done: "Fertig",
          linkCopied: "Link kopiert",
          shareText: "Machen Sie beim Wichtel-Spiel mit!"
        },
        participants: {
          title: "Teilnehmer",
          count: "Teilnehmer: {{count}}",
          join: "Beitreten",
          leave: "Spiel verlassen",
          youParticipate: "Sie nehmen teil",
          edit: "Info bearbeiten",
          kickParticipant: "Teilnehmer entfernen"
        },
        join: {
          title: "Spiel beitreten",
          displayName: "Ihr Name im Spiel",
          selectWishlist: "Wunschliste auswählen",
          preferences: "Ihre Präferenzen (optional)",
          submit: "Beitreten",
          wishlist_for_santa: "Wunschliste für den Wichtel"
        },
        assignment: {
          title: "Ihr Empfänger",
          viewWishlist: "Wunschliste ansehen",
          preferences: "Präferenzen",
          noPreferences: "Keine Präferenzen angegeben"
        },
        messages: {
          title: "Nachrichten",
          placeholder: "Nachricht schreiben...",
          send: "Senden",
          emptyState: "Beginnen Sie ein Gespräch mit Ihrem Wichtel",
          secretSanta: "Wichtel"
        },
        actions: {
          edit: "Bearbeiten",
          startDraw: "Auslosung starten",
          share: "Link teilen",
          delete: "Spiel löschen",
          organizerActions: "Organisator-Aktionen"
        },
        error: {
          createFailed: "Spiel konnte nicht erstellt werden",
          joinFailed: "Beitritt fehlgeschlagen",
          drawFailed: "Auslosung konnte nicht gestartet werden",
          insufficientParticipants: "Nicht genügend Teilnehmer (mindestens 3)",
          alreadyJoined: "Sie nehmen bereits an diesem Spiel teil",
          notOpen: "Spiel ist für neue Teilnehmer geschlossen",
          messageFailed: "Nachricht konnte nicht gesendet werden",
          loadFailed: "Spiel konnte nicht geladen werden",
          leaveFailed: "Spiel konnte nicht verlassen werden",
          updateFailed: "Info konnte nicht aktualisiert werden"
        },
        emptyState: {
          noGames: "Sie haben noch keine Spiele",
          createFirst: "Erstellen Sie Ihr erstes Wichtel-Spiel",
          noParticipants: "Teilnehmer einladen",
          waitingForDraw: "Warten auf Auslosung"
        },
        dialog: {
          leaveConfirm: "Sind Sie sicher, dass Sie das Spiel verlassen möchten?",
          deleteConfirm: "Sind Sie sicher, dass Sie das Spiel löschen möchten?",
          kickConfirm: "Sind Sie sicher, dass Sie diesen Teilnehmer aus dem Spiel entfernen möchten?",
          drawConfirm: "Sind Sie sicher, dass Sie die Auslosung starten möchten? Danach erhalten die Teilnehmer Informationen über ihre Empfänger. Die Bearbeitung von Informationen und Teilnehmern wird nicht mehr möglich sein."
        }
      },
    }
  },
  tr: {
    translation: {
      navigation: {
        main: "Ana Sayfa",
        toMain: "Ana Sayfaya",
        allWishes: "Tüm Dilekler",
      },
      state: {
        unknownError: "Bilinmeyen bir hata oluştu. Bildirimi aldık ve yakında her şeyi düzelteceğiz",
        temporaryUnavailable: "Hizmet geçici olarak kullanılamıyor. Lütfen daha sonra tekrar deneyin",
        wishlistNotFound: "Dilek listesi bulunamadı veya silindi",
        noSubscribes: "Abone olduğunuz dilek listeleri burada görüntülenecek",
        noPublicWishlists: "Henüz hiç herkese açık dilek listesi yok",
        emptyWishes: "Henüz hiç dilek yok",
        emptyGiftedWishes: "Henüz gerçekleşmiş olarak işaretlenen dilek yok",
      },
      profile: {
        titleYourProfile: "Profiliniz",
        titleYourWishlists: "Dilek Listeleriniz",
        titleUserWishlists: "Kullanıcının Dilek Listeleri",
        subscribes: "Abonelikler",
        allYourWishes: "Tüm Dilekleriniz",
        giftedWishes: "Gerçekleşen Dilekler",
        yourGiftedWishesDescription: "Gerçekleşen dilekleriniz burada görüntülenir",
        userGiftedWishesDescription: "{{name}} kullanıcısının gerçekleşen dilekleri burada görüntülenir",
        titleOtherProfile: "Kullanıcı Profili",
        settings: "Ayarlar",
        birthday: "Doğum Günü",
        actionFillBirthday: "Belirt",
        findFriends: "Arkadaşların Dilek Listelerini Bul",
      },
      settings: {
        profileData: "Profil Bilgileri",
        bookedWishes: "Rezerve Edilmiş Dilekler",
        hideBookings: {
          value: "Gizle",
          description: "Dileklerinizi birisi rezerve ettiğinde göremeyeceksiniz",
        },
        anonymousBookings: {
          value: "Anonim göster",
          description: "Dileklerinizi birisi rezerve ettiğinde göreceksiniz",
        },
        publicBookings: {
          value: "İsimleri göster",
          description: "Dileklerinizi rezerve edenlerin isimlerini göreceksiniz",
        },
        giftedWishesVisibility: {
          value: "Gerçekleşenleri göster",
          description: "Diğer kullanıcılar gerçekleşen dilekler bölümünüzü görecek",
          visibleDescription: "Profilinizi ziyaret edenler bu bölümü görür. Bunu şuradan değiştirebilirsiniz:",
          hiddenDescription: "Profilinizi ziyaret edenler bu bölümü görmez. Bunu şuradan değiştirebilirsiniz:",
          settingsLink: "ayarlar",
        },
        tgUsernameVisibility: {
          value: "Telegram username'ini göster",
          description: "Herkese açık adresiniz profilde gösterilecek",
          disabledDescription: "telegram'da herkese açık adresiniz yok",
        },
      },
      action: {
        apply: "Uygula",
        cancel: "İptal",
        edit: "Düzenle",
        delete: "Sil",
        clear: "Temizle",
        save: "Kaydet",
        add: "Ekle",
        subscribe: "Abone Ol",
        unsubscribe: "Abonelikten Çık",
        share: "Paylaş",
        shareProfile: "Profili Paylaş",
        selectPhoto: "Fotoğraf Seç",
        reorder: "Yeniden Sırala",
      },
      wish: {
        wishes: "Dilekler",
        action: {
          add: "Dilek Ekle",
          delete: "Dileği Sil",
          book: "Rezerve Et",
          cancelBooking: "Rezervasyonu İptal Et",
          openLink: "Bağlantıyı Aç",
          edit: "Dileği Düzenle",
          addToWishlists: "Dilek Listelerine Ekle",
          copyWish: "Dileği Kopyala",
        },
        dialog: {
          delete: {
            title: "Dileği Sil",
            text: "Haqiqatan ham bu dileği silmek istediğinizden emin misiniz?",
          },
          confirmHiddenBooking: "Ayarlarda rezervasyon görüntülemeyi gizlediniz. Bu dilek birisi tarafından rezerve edilmiş olabilir. Devam etmek ister misiniz?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Başlık (majburi)",
          price: "Fiyat",
          url: "Bağlantı (https://example.com...)",
          description: "Yorum / Açıklama",
        },
        gifted: {
          action: "Gerçekleşti",
          previewLabel: "Dilek",
          date: "Gerçekleşme tarihi",
          withoutDate: "Tarihsiz",
          comment: "Yorum",
          editDescription: "Açıklamayı düzenle",
          showGiftedBy: "Kimin gerçekleştirdiğini göster",
          showGiftedByNotificationHint: "Etkinleştirilirse, rezerve eden kişi dileğin yorumunuzla birlikte gerçekleşenlere taşındığına dair bildirim alır.",
          showGiftedByHint: "Dileği aslında başka biri gerçekleştirdiyse bu seçeneği kapatmanızı öneririz",
          confirmShowGiftedBy: "Bu dileği kimin rezerve ettiğini görmek istediğinizden emin misiniz?",
          giftFrom: "Hediye eden",
          giftToSelf: "Kendine hediye",
          notLoaded: "Dilek yüklenmedi",
        },
        alreadyBooked: "(rezerve edildi)",
        alreadyBookedMessage: "Bu dilek zaten birisi tarafından rezerve edildi",
        booked: "Rezerve Edildi",
        bookedBy: "Rezerve Eden:",
        bookedByYou: "Siz tomondan rezerve edildi",
        alreadyCopied: "Dileklerinize kopyalandı",
        name: {
          empty: "Dilek yok",
          one: "dilek",
          few: "dilek",
          many: "dilek",
        }
      },
      idea: {
        added: "Dilek eklendi",
        apply: "Kendine ekle",
        hide: "Fikri gizle",
        shouldHide: "Bu fikri gizlemek istiyor musunuz? Artık fikirler listesinde gösterilmeyecek",
      },
      wishlist: {
        action: {
          delete: "Dilek Listesini Sil",
          create: "Dilek Listesi Oluştur",
          edit: "Dilek Listesini Düzenle",
          selectCover: "Kapak Seç",
        },
        dialog: {
          delete: {
            title: "Dilek Listesini Sil",
            text: "Haqiqatan ham bu dilek listesini silmek istediğinizden emin misiniz?",
          },
        },
        placeholder: {
          title: "Başlık (majburi)",
          description: "Açıklama",
        },
      },
      privacy: {
        title: "Maxfiylik",
        public: {
          title: "Herkese Açık",
          description: "Profilingizde ko'rinadi",
          shortDescription: "Hammaga ko'rinadi",
        },
        link: {
          title: "Havola orqali",
          description: "Havolaga ega bo'lgan har kimga ko'rinadi",
          shortDescription: "Havola orqali ko'rinadi",
        },
        private: {
          title: "Özel",
          description: "Faqat siz ruxsat bergan odamlarga ko'rinadi",
          shortDescription: "Ruxsat bilan ko'rinadi",
        },
      },
      system: {
        birthdaySaved: "Doğum günü kaydedildi",
        unknowError: "Bilinmeyen bir hata oluştu. Tekrar deneyin",
        emptyTitle: "Başlık bo'sh olamaz",
        invalidUrl: "Geçersiz bağlantı formatı. \"https://...\" ko'rinishidagi havoladan foydalaning",
        wishDeleted: "Dilek silindi",
        wishGifted: "Dilek gerçekleşenlere taşındı",
        wishlistDeleted: "Dilek listesi silindi",
        wishlistSubscribed: "Dilek listesi aboneliklere eklendi",
        wishlistUnsubscribed: "Dilek listesi aboneliklerden olib tashlandi",
        settingsSaved: "Ayarlar kaydedildi",
        telegramChannelLinkText: "Servisin Telegram kanalı:",
        reorderSaveFailed: "Dilek sırası kaydedilemedi. Lütfen tekrar deneyin",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Oluştur"
      },
      secretSanta: {
        title: "Gizli Hediye",
        myGames: "Oyunlarım",
        create: "Oyun oluştur",
        organizer: "Organizatör",
        participant: "Katılımcı",
        status: {
          open: "Açık",
          drawn: "Çekiliş yapıldı",
          completed: "Tamamlandı"
        },
        warning: {
          title: "Organizatör olacaksınız",
          description: "Oyunu yönetmekten sorumlu olacaksınız",
          responsibility1: "Katılımcıları davet edin",
          responsibility2: "Herkes hazır olduğunda çekilişi başlatın",
          responsibility3: "Etkinliği yönetin",
          confirm: "Anladım, oyun oluştur",
        },
        form: {
          title: "Oyun başlığı",
          description: "Açıklama",
          budget: "Hediye bütçesi",
          eventDate: "Etkinlik tarihi",
          coverImage: "Kapak resmi",
          selectCurrency: "Para birimi seç"
        },
        share: {
          title: "Oyun oluşturuldu!",
          description: "Bağlantıyı katılımcılarla paylaşın",
          copyLink: "Bağlantıyı kopyala",
          shareVia: "Paylaş",
          done: "Tamam",
          linkCopied: "Bağlantı kopyalandı",
          shareText: "Gizli Hediye grubuna katılın!"
        },
        participants: {
          title: "Katılımcılar",
          count: "Katılımcılar: {{count}}",
          join: "Katıl",
          leave: "Oyundan ayrıl",
          youParticipate: "Katılıyorsunuz",
          edit: "Bilgileri düzenle",
          kickParticipant: "Katılımcıyı at"
        },
        join: {
          title: "Oyuna katıl",
          displayName: "Oyundaki adınız",
          selectWishlist: "Dilek listesi seç",
          preferences: "Tercihleriniz (isteğe bağlı)",
          submit: "Katıl",
          wishlist_for_santa: "Gizli Hediye için dilek listesi"
        },
        assignment: {
          title: "Alıcınız",
          viewWishlist: "Dilek listesini görüntüle",
          preferences: "Tercihler",
          noPreferences: "Tercih belirtilmedi"
        },
        messages: {
          title: "Mesajlar",
          placeholder: "Mesaj yaz...",
          send: "Gönder",
          emptyState: "Gizli Hediye'nizle sohbete başlayın",
          secretSanta: "Gizli Hediye"
        },
        actions: {
          edit: "Düzenle",
          startDraw: "Çekilişi başlat",
          share: "Bağlantıyı paylaş",
          delete: "Oyunu sil",
          organizerActions: "Organizatör işlemleri"
        },
        error: {
          createFailed: "Oyun oluşturulamadı",
          joinFailed: "Katılım başarısız",
          drawFailed: "Çekiliş başlatılamadı",
          insufficientParticipants: "Yetersiz katılımcı (minimum 3)",
          alreadyJoined: "Bu oyuna zaten katılıyorsunuz",
          notOpen: "Oyun yeni katılımcılara kapalı",
          messageFailed: "Mesaj gönderilemedi",
          loadFailed: "Oyun yüklenemedi",
          leaveFailed: "Oyundan ayrılınamadı",
          updateFailed: "Bilgiler güncellenemedi"
        },
        emptyState: {
          noGames: "Henüz oyununuz yok",
          createFirst: "İlk Gizli Hediye oyununuzu oluşturun",
          noParticipants: "Katılımcıları davet edin",
          waitingForDraw: "Çekiliş bekleniyor"
        },
        dialog: {
          leaveConfirm: "Oyundan ayrılmak istediğinizden emin misiniz?",
          deleteConfirm: "Oyunu silmek istediğinizden emin misiniz?",
          kickConfirm: "Bu katılımcıyı oyundan atmak istediğinizden emin misiniz?",
          drawConfirm: "Çekilişi başlatmak istediğinizden emin misiniz? Ardından katılımcılar alıcıları hakkında bilgi alacak. Bilgileri ve katılımcıları düzenlemek mümkün olmayacak."
        }
      },
    }
  },
  zh: {
    translation: {
      navigation: {
        main: "主页",
        toMain: "返回主页",
        allWishes: "所有心愿",
      },
      state: {
        unknownError: "发生未知错误。我们已收到通知，将尽快修复",
        temporaryUnavailable: "服务暂时不可用。请稍后重试",
        wishlistNotFound: "未找到心愿单或已被删除",
        noSubscribes: "这里将显示您关注的心愿单",
        noPublicWishlists: "暂无公开心愿单",
        emptyWishes: "暂无心愿",
        emptyGiftedWishes: "暂无标记为已实现的心愿",
      },
      profile: {
        titleYourProfile: "您的个人资料",
        titleYourWishlists: "您的心愿单",
        titleUserWishlists: "用户心愿单",
        subscribes: "关注",
        allYourWishes: "您的所有心愿",
        giftedWishes: "已实现的心愿",
        yourGiftedWishesDescription: "这里显示您已实现的心愿",
        userGiftedWishesDescription: "这里显示 {{name}} 已实现的心愿",
        titleOtherProfile: "用户资料",
        settings: "设置",
        birthday: "生日",
        actionFillBirthday: "填写",
        findFriends: "查找好友心愿单",
      },
      settings: {
        profileData: "个人资料",
        bookedWishes: "已预订心愿",
        hideBookings: {
          value: "隐藏",
          description: "您将看不到他人是否预订了您的心愿",
        },
        anonymousBookings: {
          value: "匿名显示",
          description: "您将看到是否有人预订了您的心愿",
        },
        publicBookings: {
          value: "显示姓名",
          description: "您将看到预订您心愿的人的姓名",
        },
        giftedWishesVisibility: {
          value: "显示已实现",
          description: "其他用户将看到您的已实现心愿部分",
          visibleDescription: "访问您个人资料的人可以看到此部分。您可以在此更改：",
          hiddenDescription: "访问您个人资料的人看不到此部分。您可以在此更改：",
          settingsLink: "设置",
        },
        tgUsernameVisibility: {
          value: "显示 Telegram username",
          description: "您的公开地址将显示在个人资料中",
          disabledDescription: "您没有 telegram 公开地址",
        },
      },
      action: {
        apply: "应用",
        cancel: "取消",
        edit: "编辑",
        delete: "删除",
        clear: "清除",
        save: "保存",
        add: "添加",
        subscribe: "关注",
        unsubscribe: "取消关注",
        share: "分享",
        shareProfile: "分享个人资料",
        selectPhoto: "选择照片",
        reorder: "重新排序",
      },
      wish: {
        wishes: "心愿",
        action: {
          add: "添加心愿",
          delete: "删除心愿",
          book: "预订",
          cancelBooking: "取消预订",
          openLink: "打开链接",
          edit: "编辑心愿",
          addToWishlists: "添加到心愿单",
          copyWish: "复制心愿",
        },
        dialog: {
          delete: {
            title: "删除心愿",
            text: "您确定要删除这个心愿吗？",
          },
          confirmHiddenBooking: "您在设置中隐藏了预订显示。这个心愿可能已被他人预订。您确定要继续吗？",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "标题（必填）",
          price: "价格",
          url: "链接 (https://example.com...)",
          description: "备注 / 描述",
        },
        gifted: {
          action: "已实现",
          previewLabel: "心愿",
          date: "实现日期",
          withoutDate: "无日期",
          comment: "评论",
          editDescription: "编辑描述",
          showGiftedBy: "显示实现者",
          showGiftedByNotificationHint: "如果开启，预订此心愿的人会收到通知，说明它已随您的评论移至已实现。",
          showGiftedByHint: "如果心愿实际由其他人实现，建议关闭此选项",
          confirmShowGiftedBy: "确定要查看是谁预订了这个心愿吗？",
          giftFrom: "礼物来自",
          giftToSelf: "送给自己的礼物",
          notLoaded: "心愿未加载",
        },
        alreadyBooked: "（已被预订）",
        alreadyBookedMessage: "此心愿已被他人预订",
        booked: "已预订",
        bookedBy: "预订者：",
        bookedByYou: "您已预订",
        alreadyCopied: "已复制到您的心愿",
        name: {
          empty: "暂无心愿",
          one: "个心愿",
          few: "个心愿",
          many: "个心愿",
        }
      },
      idea: {
        added: "心愿已添加",
        apply: "添加到我的心愿",
        hide: "隐藏想法",
        shouldHide: "您想隐藏这个想法吗？它将不再显示在想法列表中",
      },
      wishlist: {
        action: {
          delete: "删除心愿单",
          create: "创建心愿单",
          edit: "编辑心愿单",
          selectCover: "选择封面",
        },
        dialog: {
          delete: {
            title: "删除心愿单",
            text: "您确定要删除这个心愿单吗？",
          },
        },
        placeholder: {
          title: "标题（必填）",
          description: "描述",
        },
      },
      privacy: {
        title: "隐私",
        public: {
          title: "公开",
          description: "在您的个人资料中可见",
          shortDescription: "所有人可见",
        },
        link: {
          title: "通过链接",
          description: "拥有链接的人可见",
          shortDescription: "通过链接可见",
        },
        private: {
          title: "私密",
          description: "仅您允许的人可见",
          shortDescription: "需要许可可见",
        },
      },
      system: {
        birthdaySaved: "生日已保存",
        unknowError: "发生未知错误。请重试",
        emptyTitle: "标题不能为空",
        invalidUrl: "链接格式无效。请使用类似 \"https://...\" 的链接",
        wishDeleted: "心愿已删除",
        wishGifted: "心愿已移至已实现",
        wishlistDeleted: "心愿单已删除",
        wishlistSubscribed: "已关注心愿单",
        wishlistUnsubscribed: "已取消关注心愿单",
        settingsSaved: "设置已保存",
        telegramChannelLinkText: "服务的 Telegram 频道：",
        reorderSaveFailed: "保存心愿顺序失败。请重试",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "创建"
      },
      secretSanta: {
        title: "神秘圣诞老人",
        myGames: "我的游戏",
        create: "创建游戏",
        organizer: "组织者",
        participant: "参与者",
        status: {
          open: "开放",
          drawn: "已抽签",
          completed: "已完成"
        },
        warning: {
          title: "您将成为组织者",
          description: "您将负责管理游戏",
          responsibility1: "邀请参与者",
          responsibility2: "当所有人准备好时开始抽签",
          responsibility3: "管理活动",
          confirm: "明白了，创建游戏",
        },
        form: {
          title: "游戏标题",
          description: "描述",
          budget: "礼物预算",
          eventDate: "活动日期",
          coverImage: "封面图片",
          selectCurrency: "选择货币"
        },
        share: {
          title: "游戏已创建！",
          description: "与参与者分享链接",
          copyLink: "复制链接",
          shareVia: "分享",
          done: "完成",
          linkCopied: "链接已复制",
          shareText: "加入神秘圣诞老人游戏！"
        },
        participants: {
          title: "参与者",
          count: "参与者：{{count}}",
          join: "加入",
          leave: "离开游戏",
          youParticipate: "您已参与",
          edit: "编辑信息",
          kickParticipant: "踢出参与者"
        },
        join: {
          title: "加入游戏",
          displayName: "您在游戏中的名字",
          selectWishlist: "选择心愿单",
          preferences: "您的偏好（可选）",
          submit: "加入",
          wishlist_for_santa: "给神秘圣诞老人的心愿单"
        },
        assignment: {
          title: "您的收礼人",
          viewWishlist: "查看心愿单",
          preferences: "偏好",
          noPreferences: "未指定偏好"
        },
        messages: {
          title: "消息",
          placeholder: "写消息...",
          send: "发送",
          emptyState: "开始与您的神秘圣诞老人对话",
          secretSanta: "神秘圣诞老人"
        },
        actions: {
          edit: "编辑",
          startDraw: "开始抽签",
          share: "分享链接",
          delete: "删除游戏",
          organizerActions: "组织者操作"
        },
        error: {
          createFailed: "创建游戏失败",
          joinFailed: "加入失败",
          drawFailed: "开始抽签失败",
          insufficientParticipants: "参与者不足（至少3人）",
          alreadyJoined: "您已参与此游戏",
          notOpen: "游戏已关闭，不接受新参与者",
          messageFailed: "发送消息失败",
          loadFailed: "加载游戏失败",
          leaveFailed: "离开游戏失败",
          updateFailed: "更新信息失败"
        },
        emptyState: {
          noGames: "您还没有游戏",
          createFirst: "创建您的第一个神秘圣诞老人游戏",
          noParticipants: "邀请参与者",
          waitingForDraw: "等待抽签"
        },
        dialog: {
          leaveConfirm: "您确定要离开游戏吗？",
          deleteConfirm: "您确定要删除游戏吗？",
          kickConfirm: "您确定要将此参与者踢出游戏吗？",
          drawConfirm: "您确定要开始抽签吗？之后，参与者将收到有关其收礼人的信息。将无法再编辑信息和参与者。"
        }
      },
    }
  },
  uz: {
    translation: {
      navigation: {
        main: "Asosiy",
        toMain: "Asosiy sahifaga",
        allWishes: "Barcha istaklar",
      },
      state: {
        unknownError: "Noma'lum xatolik yuz berdi. Biz allaqachon xabardor qilindik va tez orada hammasi tuzatiladi",
        temporaryUnavailable: "Xizmat vaqtincha mavjud emas. Iltimos, keyinroq qayta urinib ko'ring",
        wishlistNotFound: "Istaklar ro'yxati topilmadi yoki o'chirildi",
        noSubscribes: "Bu yerda siz obuna bo'lgan istaklar ro'yxati ko'rsatiladi",
        noPublicWishlists: "Hozircha ommaviy istaklar ro'yxati yo'q",
        emptyWishes: "Hozircha istaklar yo'q",
        emptyGiftedWishes: "Hozircha amalga oshgan deb belgilangan istaklar yo'q",
      },
      profile: {
        titleYourProfile: "Sizning profilingiz",
        titleYourWishlists: "Sizning istaklar ro'yxatingiz",
        titleUserWishlists: "Foydalanuvchining istaklar ro'yxati",
        subscribes: "Obunalar",
        allYourWishes: "Barcha istaklaringiz",
        giftedWishes: "Amalga oshgan istaklar",
        yourGiftedWishesDescription: "Bu yerda amalga oshgan istaklaringiz ko'rsatiladi",
        userGiftedWishesDescription: "Bu yerda {{name}} foydalanuvchisining amalga oshgan istaklari ko'rsatiladi",
        titleOtherProfile: "Foydalanuvchi profili",
        settings: "Sozlamalar",
        birthday: "Tug'ilgan kun",
        actionFillBirthday: "To'ldirish",
        findFriends: "Do'stlarning istaklar ro'yxatini topish",
      },
      settings: {
        profileData: "Profil ma'lumotlari",
        bookedWishes: "Band qilingan istaklar",
        hideBookings: {
          value: "Yashirish",
          description: "Kimdir sizning istaklaringizni band qilganini ko'rmaysiz",
        },
        anonymousBookings: {
          value: "Anonim ko'rsatish",
          description: "Kimdir sizning istaklaringizni band qilganini ko'rasiz",
        },
        publicBookings: {
          value: "Ismlarni ko'rsatish",
          description: "Istaklaringizni band qilganlarning ismlarini ko'rasiz",
        },
        giftedWishesVisibility: {
          value: "Amalga oshganlarni ko'rsatish",
          description: "Boshqa foydalanuvchilar amalga oshgan istaklaringiz bo'limini ko'radi",
          visibleDescription: "Profilingizga tashrif buyuruvchilar bu bo'limni ko'radi. Buni o'zgartirish mumkin:",
          hiddenDescription: "Profilingizga tashrif buyuruvchilar bu bo'limni ko'rmaydi. Buni o'zgartirish mumkin:",
          settingsLink: "sozlamalar",
        },
        tgUsernameVisibility: {
          value: "Telegram username'ini ko'rsatish",
          description: "Ommaviy manzilingiz profilda ko'rsatiladi",
          disabledDescription: "telegram'da ommaviy manzilingiz yo'q",
        },
      },
      action: {
        apply: "Qo'llash",
        cancel: "Bekor qilish",
        edit: "Tahrirlash",
        delete: "O'chirish",
        clear: "Tozalash",
        save: "Saqlash",
        add: "Qo'shish",
        subscribe: "Obuna bo'lish",
        unsubscribe: "Obunani bekor qilish",
        share: "Ulashish",
        shareProfile: "Profilni ulashish",
        selectPhoto: "Rasm tanlash",
        reorder: "Tartibni o'zgartirish",
      },
      wish: {
        wishes: "Istaklar",
        action: {
          add: "Istak qo'shish",
          delete: "Istakni o'chirish",
          book: "Band qilish",
          cancelBooking: "Band qilishni bekor qilish",
          openLink: "Havolani ochish",
          edit: "Istakni tahrirlash",
          addToWishlists: "Istaklar ro'yxatiga qo'shish",
          copyWish: "Istakni nusxalash",
        },
        dialog: {
          delete: {
            title: "Istakni o'chirish",
            text: "Haqiqatan ham bu istakni o'chirmoqchimisiz?",
          },
          confirmHiddenBooking: "Siz sozlamalarda band qilishni ko'rsatishni yashirdingiz. Bu istak kimdir tomonidan band qilingan bo'lishi mumkin. Davom etishni xohlaysizmi?",
          confirmCancelOtherBooking: "Your wish is booked by someone and may already have been purchased. Are you sure you want to cancel the booking?",
        },
        placeholder: {
          title: "Sarlavha (majburiy)",
          price: "Narx",
          url: "Havola (https://example.com...)",
          description: "Izoh / Tavsif",
        },
        gifted: {
          action: "Amalga oshgan",
          previewLabel: "Istak",
          date: "Amalga oshgan sana",
          withoutDate: "Sanasiz",
          comment: "Izoh",
          editDescription: "Tavsifni tahrirlash",
          showGiftedBy: "Kim amalga oshirganini ko'rsatish",
          showGiftedByNotificationHint: "Agar yoqilgan bo'lsa, band qilgan odam istak sharhingiz bilan amalga oshganlarga ko'chirilgani haqida bildirishnoma oladi.",
          showGiftedByHint: "Agar istakni aslida boshqa odam amalga oshirgan bo'lsa, bu opsiyani o'chirishni tavsiya qilamiz",
          confirmShowGiftedBy: "Bu istakni kim band qilganini ko'rmoqchiligingizga ishonchingiz komilmi?",
          giftFrom: "Sovg'a qilgan",
          giftToSelf: "O'zingizga sovg'a",
          notLoaded: "Istak yuklanmadi",
        },
        alreadyBooked: "(band qilingan)",
        alreadyBookedMessage: "Bu istak allaqachon kimdir tomonidan band qilingan",
        booked: "Band qilingan",
        bookedBy: "Band qilgan:",
        bookedByYou: "Siz tomondan band qilingan",
        alreadyCopied: "Sizning istaklaringizga nusxalandi",
        name: {
          empty: "Istaklar yo'q",
          one: "istak",
          few: "istak",
          many: "istak",
        }
      },
      idea: {
        added: "Istak qo'shildi",
        apply: "O'zingizga qo'shish",
        hide: "G'oyani yashirish",
        shouldHide: "Bu g'oyani yashirishni xohlaysizmi? U endi g'oyalar ro'yxatida ko'rsatilmaydi",
      },
      wishlist: {
        action: {
          delete: "Istaklar ro'yxatini o'chirish",
          create: "Istaklar ro'yxatini yaratish",
          edit: "Istaklar ro'yxatini tahrirlash",
          selectCover: "Muqova tanlash",
        },
        dialog: {
          delete: {
            title: "Istaklar ro'yxatini o'chirish",
            text: "Haqiqatan ham bu istaklar ro'yxatini o'chirmoqchimisiz?",
          },
        },
        placeholder: {
          title: "Sarlavha (majburiy)",
          description: "Tavsif",
        },
      },
      privacy: {
        title: "Maxfiylik",
        public: {
          title: "Ommaviy",
          description: "Profilingizda ko'rinadi",
          shortDescription: "Hammaga ko'rinadi",
        },
        link: {
          title: "Havola orqali",
          description: "Havolaga ega bo'lgan har kimga ko'rinadi",
          shortDescription: "Havola orqali ko'rinadi",
        },
        private: {
          title: "Shaxsiy",
          description: "Faqat siz ruxsat bergan odamlarga ko'rinadi",
          shortDescription: "Ruxsat bilan ko'rinadi",
        },
      },
      system: {
        birthdaySaved: "Tug'ilgan kun saqlandi",
        unknowError: "Noma'lum xatolik yuz berdi. Qayta urinib ko'ring",
        emptyTitle: "Sarlavha bo'sh olamaz",
        invalidUrl: "Noto'g'ri havola formati. \"https://...\" ko'rinishidagi havoladan foydalaning",
        wishDeleted: "Istak o'chirildi",
        wishGifted: "Istak bajarilganlarga ko'chirildi",
        wishlistDeleted: "Istaklar ro'yxati o'chirildi",
        wishlistSubscribed: "Istaklar ro'yxati obunalarga qo'shildi",
        wishlistUnsubscribed: "Istaklar ro'yxati obunalardan olib tashlandi",
        settingsSaved: "Sozlamalar saqlandi",
        telegramChannelLinkText: "Xizmatning Telegram kanali:",
        reorderSaveFailed: "Istaklar tartibini saqlashda xatolik. Qayta urinib ko'ring",
        telegramChannelLinkUrl: "https://t.me/wishlists",
        create: "Yaratish"
      },
      secretSanta: {
        title: "Yashirin Santa",
        myGames: "Mening o'yinlarim",
        create: "O'yin yaratish",
        organizer: "Tashkilotchi",
        participant: "Ishtirokchi",
        status: {
          open: "Ochiq",
          drawn: "Qur'a tashlandi",
          completed: "Yakunlandi"
        },
        warning: {
          title: "Siz tashkilotchi bo'lasiz",
          description: "O'yinni boshqarish mas'uliyati sizda bo'ladi",
          responsibility1: "Ishtirokchilarni taklif qiling",
          responsibility2: "Hamma tayyor bo'lganda qur'a tashlang",
          responsibility3: "Tadbirni boshqaring",
          confirm: "Tushundim, o'yin yaratish",
        },
        form: {
          title: "O'yin nomi",
          description: "Tavsif",
          budget: "Sovg'a byudjeti",
          eventDate: "Tadbir sanasi",
          coverImage: "Muqova rasmi",
          selectCurrency: "Valyutani tanlang"
        },
        share: {
          title: "O'yin yaratildi!",
          description: "Havolani ishtirokchilar bilan baham ko'ring",
          copyLink: "Havolani nusxalash",
          shareVia: "Baham ko'rish",
          done: "Tayyor",
          linkCopied: "Havola nusxalandi",
          shareText: "Yashirin Santa o'yiniga qo'shiling!"
        },
        participants: {
          title: "Ishtirokchilar",
          count: "Ishtirokchilar: {{count}}",
          join: "Qo'shilish",
          leave: "O'yindan chiqish",
          youParticipate: "Siz ishtirok qilyapsiz",
          edit: "Ma'lumotlarni o'zgartirish",
          kickParticipant: "Ishtirokchini chiqarish"
        },
        join: {
          title: "O'yinga qo'shilish",
          displayName: "O'yindagi ismingiz",
          selectWishlist: "Istaklar ro'yxatini tanlang",
          preferences: "Sizning afzalliklaringiz (ixtiyoriy)",
          submit: "Qo'shilish",
          wishlist_for_santa: "Yashirin Santa uchun istaklar ro'yxati"
        },
        assignment: {
          title: "Sizning qabul qiluvchingiz",
          viewWishlist: "Istaklar ro'yxatini ko'rish",
          preferences: "Afzalliklar",
          noPreferences: "Afzalliklar ko'rsatilmagan"
        },
        messages: {
          title: "Xabarlar",
          placeholder: "Xabar yozish...",
          send: "Yuborish",
          emptyState: "Yashirin Santa bilan suhbatni boshlang",
          secretSanta: "Yashirin Santa"
        },
        actions: {
          edit: "Tahrirlash",
          startDraw: "Qur'a tashlash",
          share: "Havolani baham ko'rish",
          delete: "O'yinni o'chirish",
          organizerActions: "Tashkilotchi harakatlari"
        },
        error: {
          createFailed: "O'yin yaratib bo'lmadi",
          joinFailed: "Qo'shilish amalga oshmadi",
          drawFailed: "Qur'a tashlash amalga oshmadi",
          insufficientParticipants: "Ishtirokchilar yetarli emas (kamida 3)",
          alreadyJoined: "Siz allaqachon bu o'yinda ishtirok qilyapsiz",
          notOpen: "O'yin yangi ishtirokchilar uchun yopiq",
          messageFailed: "Xabar yuborib bo'lmadi",
          loadFailed: "O'yinni yuklab bo'lmadi",
          leaveFailed: "O'yindan chiqib bo'lmadi",
          updateFailed: "Ma'lumotlarni yangilab bo'lmadi"
        },
        emptyState: {
          noGames: "Sizda hali o'yinlar yo'q",
          createFirst: "Birinchi Yashirin Santa o'yiningizni yarating",
          noParticipants: "Ishtirokchilarni taklif qiling",
          waitingForDraw: "Qur'a kutilmoqda"
        },
        dialog: {
          leaveConfirm: "O'yindan chiqishni xohlaysizmi?",
          deleteConfirm: "O'yinni o'chirishni xohlaysizmi?",
          kickConfirm: "Ushbu ishtirokchini o'yindan chiqarishni xohlaysizmi?",
          drawConfirm: "Qur'a tashlashni xohlaysizmi? Shundan so'ng, ishtirokchilar o'z qabul qiluvchilari haqida ma'lumot olishadi. Ma'lumotlarni va ishtirokchilarni tahrirlash mumkin bo'lmaydi."
        }
      },
    }
  }
}

export const initI18n = async () => {
  const lp = retrieveLaunchParams()

  const lang = lp.initData?.user?.languageCode ?? "en";
  // split the language from region code
  const fixedLang = lang.split(/[-_]/)[0];

  await i18n.use(initReactI18next).init({
    resources: translates,
    lng: fixedLang,
    fallbackLng: "en",
  });
}

export const renderWishesCount = (count: number) => {
  const { t } = useTranslation();

  if (!count) {
    return t('wish.name.empty');
  }
  const lastTwoDigits = count % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return count + " " + t('wish.name.many');
  }
  const lastDigit = count % 10;
  if (lastDigit === 1) {
    return count + " " + t('wish.name.one');
  }
  if (lastDigit > 1 && lastDigit < 5) {
    return count + " " + t('wish.name.few');
  }
  return count + " " + t('wish.name.many');
}
